// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:35:13.443Z
// Property: Finley West (ID: 5759777107869696)
// Collections: 21 amenities, 13 floorplans (live), 24 photos, 82 POIs, 4 reviews, 5 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5759777107869696",
  "property_external_id": "4600725",
  "property_zillow_url": "https://www.zillow.com/b/9940-richmond-ave-houston-tx-5XkBgp/",
  "property_apartments_url": "https://www.apartments.com/finley-west-houston-tx/1vebd17",
  "property_google_business_url": "https://www.google.com/maps/place/Finley+West/@29.729804,-95.546223,15z/data=!4m2!3m1!1s0x0:0xd90a7d14da04f651?sa=X&ved=2ahUKEwjo8bq5guL2AhV-m2oFHSkYCbQQ_BJ6BAgmEAU",
  "property_linkedin_url": "https://www.linkedin.com/pulse/houston-rental-application-requirements-your-complete-tom-tran-mm1lc#:~:text=Employment%20History%20Be%20prepared%20to,range%20from%20$30%20to%20$75.",
  "property_hubspot_id": "8443864151",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "finley-west",
  "property_name": "Finley West",
  "property_website_url": "https://www.finleywest.com/",
  "property_domain": "https://www.finleywest.com/",
  "property_address": "9940 Richmond Ave",
  "property_full_address": "9940 Richmond Ave, Houston, TX 77042",
  "property_address_1": "9940 Richmond Ave",
  "property_address_2": null,
  "property_address_city": "Houston",
  "property_address_state": "TX",
  "property_address_zip_full": "77042-4560",
  "property_address_zip": "77042",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Westside",
  "property_address_latitude": "29.7297985",
  "property_address_longitude": "-95.5463068",
  "property_email": "finley@alapts.com",
  "property_phone": "(713) 780-4617",
  "property_call_tracking_phone": "281-784-3559",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Find your Westchase home base at Finley West.</strong> Comfortable one- and two-bedroom apartments pair polished finishes with practical storage, all in a convenient west Houston location near everyday shopping, dining, and major business corridors. Schedule your tour today.</p>",
  "property_long_description": "<p><strong>Find your Westchase home base at Finley West.</strong> Set in a convenient west Houston location near Richmond Avenue, Westheimer Road, Beltway 8, and the Westpark Tollway, this apartment community gives you quick access to everyday shopping, dining, major business corridors, and the wider Energy Corridor area.</p><p>Inside, choose from comfortable one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> with details that make home feel polished and practical: 9-foot ceilings, wood-style flooring, designer-finished countertops, oversized closets, pantry storage, USB wall outlets, washer and dryer connections, and select wood-burning fireplaces, patios, balconies, and private outside storage.</p><p>Beyond your door, Finley West keeps life easy with a refreshing pool, fitness center, package service, covered parking options, online resident services, and an onsite laundry care center. When you want fresh air, explore nearby Camden Park, Robinson-Westchase Library, and Westchase District’s growing trail network, including the Library Loop and Brays Bayou connections. Discover more around the area on the <a href=\"/neighborhood\">neighborhood guide</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019d02f4-e132-770b-8f41-d54453ad3007.webp",
  "property_featured_image_media": {
    "alt_text": "Stylish living room with dining area and open kitchen.",
    "public_id": "019d02f4-e132-770b-8f41-d54453ad3007",
    "storage_key": "property/5759777107869696/019d02f4-e132-770b-8f41-d54453ad3007.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "224",
  "property_year_built": "1980",
  "property_year_renovated": "2026",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.07142857142857",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nApplication Approval Fee Starting at $300\nNon-Refundable Pet Fee $350 / pet\nMonthly Pet Rent $25 / pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8113534.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://finleywest.loftliving.com/login",
  "property_apply_now_url": "https://8113534.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e6a98-8a76-729b-8c8b-f9a20b765f98.webp",
  "property_primary_logo_media": {
    "alt_text": "Finley West Premier Apartments Logo",
    "public_id": "019e6a98-8a76-729b-8c8b-f9a20b765f98",
    "storage_key": "property/5759777107869696/019e6a98-8a76-729b-8c8b-f9a20b765f98.webp",
    "width": 2655,
    "height": 1113
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e6a98-8ba8-74a7-a5e9-d8b54d643895.webp",
  "property_secondary_logo_media": {
    "alt_text": "Finley West logo",
    "public_id": "019e6a98-8ba8-74a7-a5e9-d8b54d643895",
    "storage_key": "property/5759777107869696/019e6a98-8ba8-74a7-a5e9-d8b54d643895.webp",
    "width": 2655,
    "height": 1113
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e6a98-8dae-777d-a835-d305f64a291d.webp",
  "property_icon_media": {
    "alt_text": "FW logo",
    "public_id": "019e6a98-8dae-777d-a835-d305f64a291d",
    "storage_key": "property/5759777107869696/019e6a98-8dae-777d-a835-d305f64a291d.webp",
    "width": 865,
    "height": 865
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e6a98-8dae-777d-a835-d305f64a291d.webp",
  "property_fav_icon_media": {
    "alt_text": "FW logo",
    "public_id": "019e6a98-8dae-777d-a835-d305f64a291d",
    "storage_key": "property/5759777107869696/019e6a98-8dae-777d-a835-d305f64a291d.webp",
    "width": 865,
    "height": 865
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e6a98-8ad0-7441-b8e6-5355c64b58ee.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Finley West Premier Apartments logo",
    "public_id": "019e6a98-8ad0-7441-b8e6-5355c64b58ee",
    "storage_key": "property/5759777107869696/019e6a98-8ad0-7441-b8e6-5355c64b58ee.webp",
    "width": 2655,
    "height": 1113
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f42a6-935f-72ff-bb38-4d10a03d20f4.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f42a6-935f-72ff-bb38-4d10a03d20f4",
    "storage_key": "property/5759777107869696/019f42a6-935f-72ff-bb38-4d10a03d20f4.webp",
    "width": 1280,
    "height": 536
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#4779af",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#8faa69",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "733 - 1262",
  "property_sqft_min": "733",
  "property_sqft_max": "1262",
  "property_price_range": "1221 - 1603",
  "property_price_min": "1221",
  "property_price_max": "1603",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/FinleyWestApts",
  "property_instagram_url": "https://www.instagram.com/finleywestapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJhzuzpCTDQIYRUfYE2hR9Ctk",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/finley-west-houston",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Everyday amenities, thoughtfully dialed in.</strong> Swim beside the sundeck-lined pool, recharge in the strength and cardio fitness center, and simplify routines with covered parking options, package service, a 24-hour package system, online resident services, and onsite laundry care.</p><p>Inside, polished finishes include high ceilings, wood-style flooring, stainless steel appliances, designer countertops, oversized closets, USB wall outlets, and full-size washer/dryer connections, with select homes adding fireplaces, patios or balconies, and outdoor storage.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to settle in.</strong> Explore one- and two-bedroom apartments in Westchase with open living areas, defined dining space, pantry storage, and oversized closets. Finishes like high ceilings, hardwood-style flooring, designer countertops, double-basin sinks, and full-size washer/dryer connections add everyday polish, while select homes offer a wood-burning fireplace, patio or balcony, and outdoor storage.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at Finley West.</strong> Preview a sparkling pool with lounge seating, a bright fitness center with vaulted beams and pool views, and interiors styled with wood-style flooring, designer countertops, and stainless steel appliances. From open living spaces and pantry-equipped kitchens to private patios, balconies, fireplaces, and generous closets, the gallery captures the details that make these Westchase apartments easy to explore.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Westchase puts Houston within easy reach.</strong> From Finley West, office hubs, Westheimer dining, the Sam Houston Tollway, the Galleria, and the Energy Corridor are all close by. Grab coffee at Carillon, stock up at Whole Foods, Kroger, Target, or Aldi, then unwind at Woodchase Park with its lawn, pavilion, dog park, garden, and exercise stations.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to praise at Finley West.</strong> Reviews call out smooth move-ins, a helpful office team, and maintenance that’s prompt, professional, and friendly. Clean, quiet surroundings and a convenient Richmond Ave location add to the everyday ease, while spacious layouts, stainless steel appliances, large balconies, the pool, and 24-hour gym earn frequent mentions. Above all, residents highlight a team that goes above and beyond to keep the community well cared for.</p>",
  "property_neighborhood_blurb": "<p><strong>Westchase keeps your day moving.</strong> From Finley West, you’re close to the neighborhood’s office district, Westheimer dining, and the Sam Houston Tollway, with quick ways to reach the Galleria, Energy Corridor, and west Houston errands. Start with coffee or brunch at Carillon, explore globally inspired bites along Westheimer, or make a simple grocery run with Whole Foods, Kroger, Target, Aldi, and more nearby.</p><p>When you want time outside, Woodchase Park brings a lawn, pavilion, dog park, community garden, and exercise stations into the district, while Westchase’s connected trail system links everyday routes across the area. Come home to an apartment setting that pairs neighborhood convenience with your own pool, fitness center, and package service—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Finley West fits your map.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make every day feel more considered.</strong> At Finley West in Westchase, start with a swim by the sundeck-lined pool, fit in a workout at the strength and cardio fitness center, and keep errands simple with covered parking options, package service, a 24-hour package system, online resident services, and an onsite laundry care center.</p><p>Inside, the details feel polished without losing practicality: high ceilings, wood-style flooring, designer-finished countertops, stainless steel appliances, double-basin sinks, pantry space, oversized closets, USB wall outlets, and full-size washer and dryer connections. Select layouts add a wood-burning fireplace, private patio or balcony, and outdoor storage for extra breathing room. See how it all comes together in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities firsthand.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Finley West your Westchase home base?</strong><br>Choose a polished one- or two-bedroom apartment with practical finishes, easy everyday access, and resident conveniences that keep life moving. Start your online application today and take the next step toward calling Finley West home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong><br>Reach out to the Finley West leasing team for help finding your way to our convenient west Houston location near Richmond Avenue, Westheimer Road, Beltway 8, and the Westpark Tollway. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Finley West?</strong> Start here for quick answers about the community, leasing, floor plans, features, and everyday living in west Houston. If you don’t see what you need, the leasing team is happy to help you find the right next step.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the space that fits your rhythm.</strong> Finley West offers one- and two-bedroom apartment layouts in Westchase, including two-bedroom options with two full baths or an added half bath for extra everyday ease. Open living areas, defined dining space, pantry storage, and oversized closets help each floor plan feel organized from the moment you move in.</p><p>Inside, details like high ceilings, hardwood-style flooring, designer-finished countertops, double-basin kitchen sinks, and full-size washer and dryer connections bring comfort into your daily routine. Select homes add a wood-burning fireplace, private patio or balcony, and outdoor storage for a little more room to settle in. Browse current availability, compare layouts, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how your favorite floor plan feels in person.</p>",
  "property_gallery_blurb": "<p><strong>See Finley West in frame.</strong> Browse the gallery for a closer look at the spaces that shape everyday living in Westchase: a sparkling pool edged with lounge seating, a bright fitness center with vaulted beams and pool views, and apartment interiors finished with wood-style flooring, designer countertops, and stainless steel appliances. Photos move from kitchens with pantry storage to open living and dining areas, then out to private patios, balconies, landscaped lawns, and community spaces that add texture to the setting. As you explore each image, notice how natural light, high ceilings, fireplaces, and generous closets help these one- and two-bedroom layouts feel comfortable and easy to imagine. Want to look closer? Continue with <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Finley West on the map.</strong> See available apartments in a convenient Westchase location near Richmond Avenue, Westheimer Road, Beltway 8, and the Westpark Tollway—then get a feel for nearby shopping, dining, business corridors, trails, and Energy Corridor access.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, zoomies, and easy routines.</strong> At Finley West, your cat or dog can settle into a pet-friendly apartment with no weight limit and everyday comforts that make life simpler, from roomy closets for leashes and toys to select private patios or balconies for a breath of fresh air.</p><p>Step out for a stroll through the community’s mature landscaping, then head into Westchase for nearby dog-friendly green space when your pup needs a longer outing. Back home, convenient resident services, package access, and practical <a href=\"/amenities\">apartment features</a> help keep food deliveries, cleanup supplies, and daily care easy to manage. Have a question about your pet? <a href=\"/contact-us\">Contact the leasing team</a> for current policy details.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at Finley West?</strong> Share the comfort, convenience, and Westchase access that make this west Houston home base stand out. Invite a friend to explore polished one- and two-bedroom apartments, easy online resident services, and community spaces designed for everyday ease.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Finley West.</strong><br>Pay rent, submit maintenance requests, and manage your account online—made to keep life easy at your Westchase home base. Log in anytime for simple service that supports your day-to-day routine.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents love about Finley West.</strong> Reviews highlight an easy move-in experience, a helpful office team, and maintenance service described as prompt, professional, and friendly. Residents also point to a clean, quiet community and a location that makes day-to-day living feel convenient.</p><p>Inside the apartments, reviewers mention spacious layouts, upgraded stainless steel appliances, and large balconies, while community features like the pool and 24-hour gym add everyday value. Most of all, residents praise the people behind the property, saying the team has “gone above and beyond” to answer questions, handle concerns, and make Finley West feel well cared for.</p>",
  "property_created_at": "1752256726285",
  "property_scheduletour_blurb": "<p><strong>See Finley West in person.</strong> Tour comfortable one- and two-bedroom floor plans with 9-foot ceilings, wood-style flooring, designer-finished countertops, and oversized closets, then get a feel for community conveniences like the pool, fitness center, and covered parking options. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Finley West.</strong><br>Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture a polished Westchase home base with comfortable one- and two-bedroom layouts, practical in-home finishes, and easy access to west Houston shopping, dining, and major corridors.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> Explore Finley West with virtual tours that let you move through the apartment spaces, pool, and strength and cardio fitness center at your own pace. Start with the apartment walkthroughs to compare two-bedroom, two-bath layouts, check the flow from living area to kitchen, and look closer at finishes like wood-style flooring, stainless steel appliances, designer-style countertops, a fireplace, generous closets, and patio or balcony access in select homes.</p><p>Then head outdoors to see the freeform pool framed by brick buildings and lounge seating, followed by a bright fitness center with vaulted beams, mirrored walls, cardio machines, and strength-training equipment. When you’re ready to see it in person, <a href=\"/schedule-a-tour\">schedule a tour</a> or compare available <a href=\"/floor-plans\">floor plans</a>.</p>",
  "property_copyright": "2025 All Rights Reserved. Finley West",
  "property_seo_title_home": "Finley West | Apartments in Houston, TX",
  "property_seo_description_home": "Unlock your ideal lifestyle at Finley West in Houston, TX. Choose from one or two-bedroom layouts, and enjoy top-notch amenities like a fitness center and pool.",
  "property_seo_title_floorplans": "Find your ideal living space at Finley West in Houston! Choose from stylish one and two-bedroom floor plans tailored for comfort and style. Browse now!",
  "property_seo_description_floorplans": "Find your ideal space at Finley West in Houston, TX! Choose from stylish one and two-bedroom floor plans tailored for modern living. Your dream home awaits!",
  "property_seo_title_amenities": "Amenities | Houston, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience Finley West in Houston, TX! Enjoy stylish one and two-bedroom apartments with top-notch amenities like a pool, fitness center, and more. Live well!",
  "property_seo_title_gallery": "Gallery | Apartments in Houston, TX",
  "property_seo_description_gallery": "\"Picture life at Finley West in Houston, TX! Immerse in stunning floor plans, luxe amenities, and a pool view that transforms your everyday living.\"",
  "property_seo_title_virtualtours": "Virtual Tours | Finley West Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Finley West in Houston, TX! Enjoy spacious one and two-bedroom floor plans. Take a virtual tour and find your perfect home today!",
  "property_seo_title_interactivemap": "Interactive Map | Finley West Apartments",
  "property_seo_description_interactivemap": "Find your perfect space at Finley West in Houston, TX! Use our interactive map to view stunning floor plans and amenities. Your ideal apartment awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Houston, TX",
  "property_seo_description_neighborhood": "Uncover the vibrant Houston neighborhood surrounding Finley West. Delight in local favorites—dining, shopping, and parks—all just steps from your home.",
  "property_seo_title_contact": "Contact Us | Finley West",
  "property_seo_description_contact": "Connect with Finley West in Houston, TX! Whether you're interested in one or two-bedroom floor plans, our leasing team is here to help. Reach out now!",
  "property_seo_title_faqs": "FAQs | Apartments in Houston, TX",
  "property_seo_description_faqs": "\"Get all the answers about life at Finley West in Houston, TX! From floor plans to amenities, our FAQs cover everything you need to know. Dive in today!\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Houston, TX",
  "property_seo_description_reviews": "Read what our residents love about Finley West in Houston, TX! Enjoy amenities like a fitness center, pool, and modern floor plans for a vibrant lifestyle.",
  "property_seo_title_applynow": "Apply Now | Apartments in Houston, TX",
  "property_seo_description_applynow": "Elevate your lifestyle at Finley West in Houston, TX! Enjoy spacious one and two-bedroom designs, luxury amenities, and convenient online leasing. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Finley West",
  "property_seo_description_residentaccess": "Log in to the Finley West resident portal in Houston to effortlessly manage rent, request maintenance, and stay connected with your community.",
  "property_seo_title_referafriend": "Refer A Friend | Finley West",
  "property_seo_description_referafriend": "\"Great friends make great neighbors! Refer a friend to Finley West in Houston, TX, and enjoy the perks of connecting with your vibrant new community today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Finley West",
  "property_seo_description_scheduletour": "Experience the charm of Finley West in Houston, TX. Schedule a tour today and envision your upgraded lifestyle in our vibrant apartment community!",
  "property_seo_title_privacy": "Privacy Policy | Finley West",
  "property_seo_description_privacy": "At Finley West, your privacy matters. Learn how we protect your personal information while you enjoy life in vibrant Houston, TX. View our privacy policy today.",
  "property_seo_title_accessibility": "Website Accessibility | Finley West",
  "property_seo_description_accessibility": "Experience seamless living at Finley West in Houston, TX. Our commitment to accessibility ensures everyone enjoys comfortable, inclusive apartment living.",
  "property_seo_title_sitemap": "Sitemap | Finley West",
  "property_seo_description_sitemap": "Unearth the full layout of Finley West in Houston, TX! Navigate our sitemap to find your ideal apartment and start your journey to luxurious living today.",
  "property_seo_title_thankyou": "Thank You | Finley West",
  "property_seo_description_thankyou": "Thank you for reaching out to Finley West in Houston! Our team will connect soon to guide you home to vibrant living and exceptional amenities. ",
  "property_seo_title_pets": "Pet Policy | Apartments in Buford, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319893",
  "amenities": [
    {
      "id": "custom_120a97ff-953b-46b0-98bb-f8a9f629578a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e7a4cc4c-024d-4cfd-aeee-3957b87d3636",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000603",
      "title": "Blinds",
      "amount": "0.0000",
      "description": "Two Inch Blinds",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d03138e4-993b-42e4-b5fd-dcd21bb84b53",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Designer Finished Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_df5d26a8-d609-4580-8a72-2ef378d59a8b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000623",
      "title": "Covered Parking",
      "amount": "0.0000",
      "description": "Covered Parking Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0616f03e-9c00-48a1-84bc-7feb44d9005b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000633",
      "title": "Fire",
      "amount": "0.0000",
      "description": "Wood Burning Fireplace",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7d4bc5b5-40d2-43cb-b747-be3fd52cb7f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern Strength & Cardio Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a722f960-b40b-419b-bca4-3b1e0e9179ea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_743f41bc-5adc-44bc-a646-b8e097250a06",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8b9cc618-ce01-45a7-9f64-20600ced177a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000656",
      "title": "Laundry Rooms",
      "amount": "0.0000",
      "description": "Onsite Resident Laundry Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e7beff5a-130d-4b49-bb98-c8a386c414ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ed0505c-ccb7-4f16-b3d6-abe61135a6c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ec982c50-0dc9-43a8-92fb-2e9fe50e5598",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000665",
      "title": "Package System",
      "amount": "0.0000",
      "description": "24-Hour Resident Package System",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d10a7177-6769-45b4-b921-e423a5964adb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000666",
      "title": "Pantry Closets",
      "amount": "0.0000",
      "description": "Pantry Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f468dec1-b32e-41d4-80e2-e6b422070d5e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool with Sundeck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_97e85985-d8d7-43f9-ab87-d2351d3a5f1d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000674",
      "title": "School District",
      "amount": "0.0000",
      "description": "Alief School District",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f7b21577-4147-4eb1-a612-232d190ad745",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000676",
      "title": "Sink",
      "amount": "0.0000",
      "description": "Double Basin Kitchen Sinks with Disposal",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4247bd2d-6f80-45ab-95de-5b158da7c972",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000687",
      "title": "Storage Spaces",
      "amount": "0.0000",
      "description": "Private Outside Storage",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_67c04c06-7ced-4163-a324-db6be4e9e63c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9 Foot Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9b029294-8386-4142-90c4-5547e378512b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "Wall Outlets with USB Ports",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7bd22f85-73a7-4b06-b261-fa50512f1954",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000703",
      "title": "W&D Connections",
      "amount": "0.0000",
      "description": "Full Size Washer and Dryer Connections",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9fb095b4-b020-4066-8702-bab992ef92c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Oversized Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_00a0d9de-0d07-4c34-afa2-c0fd64227e6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8999-0019-7717-9b9d-67b435a31be9.webp",
      "image_media": {
        "alt_text": "Smart package lockers with Finley West branding outside apartment buildings.",
        "public_id": "019e8999-0019-7717-9b9d-67b435a31be9",
        "storage_key": "property/5759777107869696/019e8999-0019-7717-9b9d-67b435a31be9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern smart package lockers, branded with Finley West, offer secure and convenient package delivery for residents.",
      "link": "",
      "alt_text": "Smart package lockers with Finley West branding outside apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1e245b55-cd38-4fb0-9b76-b643a1457c57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-ef35-73bc-a788-6c4d2fea2a6b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019e8998-ef35-73bc-a788-6c4d2fea2a6b",
        "storage_key": "property/5759777107869696/019e8998-ef35-73bc-a788-6c4d2fea2a6b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs and shaded umbrellas for ultimate relaxation. An inviting community amenity for all residents.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c0079148-98b9-466c-ab1b-13173321ee60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8999-0197-71d3-896a-f41982936911.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, dresser, and nightstand.",
        "public_id": "019e8999-0197-71d3-896a-f41982936911",
        "storage_key": "property/5759777107869696/019e8999-0197-71d3-896a-f41982936911.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Experience luxurious comfort in this spacious bedroom, featuring a king-size bed, elegant dresser, and stylish nightstand.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1837372a-0cfc-44b5-bf00-a3bac1a0ea47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-eee1-772c-9334-f4cbf1f8587a.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a queen-size bed, ceiling fan, and modern decor.",
        "public_id": "019e8998-eee1-772c-9334-f4cbf1f8587a",
        "storage_key": "property/5759777107869696/019e8998-eee1-772c-9334-f4cbf1f8587a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover comfort and style in our well-appointed bedrooms. Featuring plush bedding, contemporary finishes, and ample natural light.",
      "link": "",
      "alt_text": "Stylish bedroom with a queen-size bed, ceiling fan, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ce3abe5-4492-4b1c-a3bd-efaa6693cd00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-edaf-74e6-9e46-27839536f015.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a walk-in pantry.",
        "public_id": "019e8998-edaf-74e6-9e46-27839536f015",
        "storage_key": "property/5759777107869696/019e8998-edaf-74e6-9e46-27839536f015.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, granite countertops, stainless steel appliances, and ample storage with a convenient walk-in pantry.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a walk-in pantry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7a8f83ee-67e5-40eb-ba7d-763da4cea78c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-eda2-7672-a990-b4e58516f6ea.webp",
      "image_media": {
        "alt_text": "Modern fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019e8998-eda2-7672-a990-b4e58516f6ea",
        "storage_key": "property/5759777107869696/019e8998-eda2-7672-a990-b4e58516f6ea.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring state-of-the-art cardio machines, strength training equipment, and free weights for a complete workout.",
      "link": "",
      "alt_text": "Modern fitness center with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2f9a251a-7f4d-4c18-8744-e9097985f2a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-f64c-763c-8481-9dfca36aa0f3.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with bar seating",
        "public_id": "019e8998-f64c-763c-8481-9dfca36aa0f3",
        "storage_key": "property/5759777107869696/019e8998-f64c-763c-8481-9dfca36aa0f3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish dining area adjacent to a kitchen with a breakfast bar, perfect for entertaining or casual meals.",
      "link": "",
      "alt_text": "Dining area and kitchen with bar seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b06f60ae-f903-4563-b5e9-e7577713e181",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-f953-73f8-87d2-d3a87b1e39a8.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines and weight training equipment, overlooking the pool.",
        "public_id": "019e8998-f953-73f8-87d2-d3a87b1e39a8",
        "storage_key": "property/5759777107869696/019e8998-f953-73f8-87d2-d3a87b1e39a8.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines and weight training equipment. Enjoy a workout with a view of the sparkling pool.",
      "link": "",
      "alt_text": "Fitness center with cardio machines and weight training equipment, overlooking the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2baa5507-9220-4daa-b991-75363efc93a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-ef8e-7153-b4c2-9cc7720fbadc.webp",
      "image_media": {
        "alt_text": "Starbucks coffee station and a gym with treadmills visible through a glass door.",
        "public_id": "019e8998-ef8e-7153-b4c2-9cc7720fbadc",
        "storage_key": "property/5759777107869696/019e8998-ef8e-7153-b4c2-9cc7720fbadc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy complimentary Starbucks coffee and coffee bar in the resident lounge. Access the fitness center and treadmills right next door.",
      "link": "",
      "alt_text": "Starbucks coffee station and a gym with treadmills visible through a glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c349e496-3c60-4c8e-b162-dc21a4cda640",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-ef77-765f-b207-e9467c7ffe71.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, TV, sofa, and kitchen counter with bar stools.",
        "public_id": "019e8998-ef77-765f-b207-e9467c7ffe71",
        "storage_key": "property/5759777107869696/019e8998-ef77-765f-b207-e9467c7ffe71.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a cozy fireplace, a mounted TV, comfortable sofa, and a breakfast bar with stools, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with fireplace, TV, sofa, and kitchen counter with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b846c1ed-c384-4785-8358-9a8563a8a2c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-e5bd-715e-acec-e4ab980256bb.webp",
      "image_media": {
        "alt_text": "Open-concept living and dining area with a kitchen view.",
        "public_id": "019e8998-e5bd-715e-acec-e4ab980256bb",
        "storage_key": "property/5759777107869696/019e8998-e5bd-715e-acec-e4ab980256bb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area seamlessly transitions into a modern kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Open-concept living and dining area with a kitchen view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a9faf182-bed4-46ac-8033-3673f5b829f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-e70c-751a-97bc-2ce7b23d07d0.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e8998-e70c-751a-97bc-2ce7b23d07d0",
        "storage_key": "property/5759777107869696/019e8998-e70c-751a-97bc-2ce7b23d07d0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas. Enjoy the resort-style amenities at our apartment community.",
      "link": "",
      "alt_text": "Apartment complex swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a52ca8c7-e88a-4592-ac2a-31a2524e7c44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-da63-77ee-ba5b-7f6cac9c6156.webp",
      "image_media": {
        "alt_text": "Finley West Premier Apartments monument sign with landscaping and apartment buildings in the background.",
        "public_id": "019e8998-da63-77ee-ba5b-7f6cac9c6156",
        "storage_key": "property/5759777107869696/019e8998-da63-77ee-ba5b-7f6cac9c6156.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to Finley West Premier Apartments, featuring lush landscaping and well-maintained apartment buildings.",
      "link": "",
      "alt_text": "Finley West Premier Apartments monument sign with landscaping and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_51b2186a-e585-449d-8fe3-c517f725b146",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-caa3-727c-aca1-381587f0a5a4.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool surrounded by apartment buildings.",
        "public_id": "019e8998-caa3-727c-aca1-381587f0a5a4",
        "storage_key": "property/5759777107869696/019e8998-caa3-727c-aca1-381587f0a5a4.webp",
        "width": 3072,
        "height": 2303
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our beautiful outdoor pool, the perfect place to relax and soak up the sun.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_11ab268f-684e-4f2b-a640-509552f1990a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-d6fd-765f-af6f-f6e729a29759.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and shower/tub combo with marble-patterned curtains.",
        "public_id": "019e8998-d6fd-765f-af6f-f6e729a29759",
        "storage_key": "property/5759777107869696/019e8998-d6fd-765f-af6f-f6e729a29759.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this beautifully appointed bathroom, featuring a spacious vanity, a modern toilet, and a refreshing shower/tub combination.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and shower/tub combo with marble-patterned curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59bf4f5f-1217-4204-adfc-4bce44ec2c62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-cb02-72fb-9936-b4b2a9324cdb.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with brick and gray siding, with a central staircase and green lawns.",
        "public_id": "019e8998-cb02-72fb-9936-b4b2a9324cdb",
        "storage_key": "property/5759777107869696/019e8998-cb02-72fb-9936-b4b2a9324cdb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the beautifully maintained grounds and exteriors of our apartment community, featuring lush green spaces and modern architectural elements.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with brick and gray siding, with a central staircase and green lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7e0e2ef6-a8b3-4353-bb1a-d1b792eaa308",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-cae7-743d-abe4-70eda76b9fb0.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and shower with patterned curtain.",
        "public_id": "019e8998-cae7-743d-abe4-70eda76b9fb0",
        "storage_key": "property/5759777107869696/019e8998-cae7-743d-abe4-70eda76b9fb0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and clean apartment bathroom featuring a modern vanity, sink, toilet, and a bathtub with a decorative shower curtain. In-unit laundry is visible in the reflection.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, toilet, and shower with patterned curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dc49d61a-8b72-42af-b955-3dc4254ed1af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-c983-70fa-beec-c969a2838be8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a pantry.",
        "public_id": "019e8998-c983-70fa-beec-c969a2838be8",
        "storage_key": "property/5759777107869696/019e8998-c983-70fa-beec-c969a2838be8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stunning kitchen featuring dark wood cabinetry, gleaming granite countertops, and a full suite of stainless steel appliances. Ample pantry space for all your storage needs.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a pantry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bf624892-6cf4-43c2-b663-afc7681844d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-c8b4-705d-b8af-8d33d958f3ab.webp",
      "image_media": {
        "alt_text": "Modern living room with blue accent wall and abstract art.",
        "public_id": "019e8998-c8b4-705d-b8af-8d33d958f3ab",
        "storage_key": "property/5759777107869696/019e8998-c8b4-705d-b8af-8d33d958f3ab.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, accent chairs, and a coffee table, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with blue accent wall and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c9b8d684-ecd0-4c1e-bd6e-33e01a9da7e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-ca36-70aa-b5fd-86a79d8cb120.webp",
      "image_media": {
        "alt_text": "Modern living room with dark gray couch, blue accent chairs, glass coffee table, and artwork.",
        "public_id": "019e8998-ca36-70aa-b5fd-86a79d8cb120",
        "storage_key": "property/5759777107869696/019e8998-ca36-70aa-b5fd-86a79d8cb120.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Step into a beautifully designed living space featuring plush seating, elegant decor, and ample natural light, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with dark gray couch, blue accent chairs, glass coffee table, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b6cf91f-f47d-4ab8-b0cc-850d7faad756",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-caaa-70ca-a574-cc03b3313697.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019e8998-caaa-70ca-a574-cc03b3313697",
        "storage_key": "property/5759777107869696/019e8998-caaa-70ca-a574-cc03b3313697.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge seating and shaded areas for relaxation. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_61642811-de13-4ab2-86db-f0b70ee8c3a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-c994-707a-9168-1e743b6ebede.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, TV, and modern decor.",
        "public_id": "019e8998-c994-707a-9168-1e743b6ebede",
        "storage_key": "property/5759777107869696/019e8998-c994-707a-9168-1e743b6ebede.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a fireplace, mounted TV, and contemporary furniture. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with fireplace, TV, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a72e83de-f939-4e43-9692-9d157151e03c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-bbf4-704e-80bd-5c7d55c260b5.webp",
      "image_media": {
        "alt_text": "Exterior walkway with stairs leading to apartment entrances surrounded by lush landscaping.",
        "public_id": "019e8998-bbf4-704e-80bd-5c7d55c260b5",
        "storage_key": "property/5759777107869696/019e8998-bbf4-704e-80bd-5c7d55c260b5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Walk through the beautifully landscaped grounds to your charming apartment home, featuring convenient exterior stair access.",
      "link": "",
      "alt_text": "Exterior walkway with stairs leading to apartment entrances surrounded by lush landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bbbe2dc6-39b9-4676-a1ad-973c9dd9a898",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019e8998-bbf2-73ff-842a-f8c9ca9c1caa.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with louvered doors.",
        "public_id": "019e8998-bbf2-73ff-842a-f8c9ca9c1caa",
        "storage_key": "property/5759777107869696/019e8998-bbf2-73ff-842a-f8c9ca9c1caa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer, tucked away behind louvered doors for a clean look. Includes overhead shelving for storage.",
      "link": "",
      "alt_text": "In-unit washer and dryer with louvered doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_426155ad2795606c8f16ecf1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Simon's Chinese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "10440 Richmond Ave, Houston, TX 77042, USA",
      "poi_short_description": "Relaxed eatery dishing up Chinese classics plus boba tea and other options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-d1dc-7657-b5e7-420fd18e9d4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-d1dc-7657-b5e7-420fd18e9d4c",
        "storage_key": "property/5759777107869696/019f1508-d1dc-7657-b5e7-420fd18e9d4c.webp",
        "width": 1280,
        "height": 1270
      },
      "poi_business_url": "https://www.simonschineserestauranttx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8698686675522532514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simons-chinese-restaurant",
      "poi_latitude": "29.7282871",
      "poi_longitude": "-95.5592463",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 346-361-0888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d5-701b-a249-c57cc5a7cb9e",
        "storage_key": "property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK8S4Xg7DQIYRorTxmnHxt3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_db48670f989b5dc24dd70efa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Twin Crab",
      "poi_type": "Restaurants",
      "poi_address": "10465 Richmond Ave, Houston, TX 77042, USA",
      "poi_short_description": "Comfortable seafood specialist known for its Cajun-style boils, fried dishes and wings, plus beers and cocktails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-d43f-73eb-8d9c-3ac6f8cf9928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-d43f-73eb-8d9c-3ac6f8cf9928",
        "storage_key": "property/5759777107869696/019f1508-d43f-73eb-8d9c-3ac6f8cf9928.webp",
        "width": 1280,
        "height": 907
      },
      "poi_business_url": "https://dine.bychronos.com/l/houston-seafood-twin-crab-juicy-seafood-and-bar-richmond-802",
      "poi_directions_map_url": "https://maps.google.com/?cid=574991619283224689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "twin-crab",
      "poi_latitude": "29.7270477",
      "poi_longitude": "-95.5592258",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-688-6868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d5-701b-a249-c57cc5a7cb9e",
        "storage_key": "property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzW8HE4nDQIYRcQg00NTH-gc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_fb87b5558cb5fa2629b9c2fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Palazzo's: Westchase",
      "poi_type": "Restaurants",
      "poi_address": "10455 Briar Forest Dr, Houston, TX 77042, USA",
      "poi_short_description": "Neighborhood outpost of a local chain trattoria serving specialty pizza & Italian favorites.",
      "poi_long_description": "Neighborhood outpost of a local chain trattoria serving specialty pizza & Italian favorites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-cc65-765a-9d59-193ea518c857.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-cc65-765a-9d59-193ea518c857",
        "storage_key": "property/5759777107869696/019f1508-cc65-765a-9d59-193ea518c857.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.palazzos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2298801232806721675&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palazzos-westchase",
      "poi_latitude": "29.7470171",
      "poi_longitude": "-95.5601785",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-785-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d5-701b-a249-c57cc5a7cb9e",
        "storage_key": "property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYfgvZ0vDQIYRi7isqor75h8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_85929ec5ded77d548f20bcc1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Avesta Persian Middle Eastern",
      "poi_type": "Restaurants",
      "poi_address": "11165 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Strip-mall storefront offering Middle Eastern cuisine like stews & kebabs in modest environs.",
      "poi_long_description": "Strip-mall storefront offering Middle Eastern cuisine like stews & kebabs in modest environs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-d956-71f9-a1ba-ca651cd5f7c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-d956-71f9-a1ba-ca651cd5f7c8",
        "storage_key": "property/5759777107869696/019f1508-d956-71f9-a1ba-ca651cd5f7c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.avestahouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3154407663395890618&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "avesta-persian-middle-eastern",
      "poi_latitude": "29.7355678",
      "poi_longitude": "-95.5729048",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-781-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d5-701b-a249-c57cc5a7cb9e",
        "storage_key": "property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-5rPUs_cQIYRumV7nQ61xis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "persian_restaurant"
    },
    {
      "id": "ec_d4118438bd1b1ba4d2be6277",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "W Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10928 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Informal strip-mall restaurant offering draft beer & generous plates of classic Chinese fare.",
      "poi_long_description": "Informal strip-mall restaurant offering draft beer & generous plates of classic Chinese fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-e119-707a-a0b2-a1536199d8b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-e119-707a-a0b2-a1536199d8b1",
        "storage_key": "property/5759777107869696/019f1508-e119-707a-a0b2-a1536199d8b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://wkitchenhtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16224291091525338082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "w-kitchen",
      "poi_latitude": "29.7378556",
      "poi_longitude": "-95.5690615",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 346-388-2288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d5-701b-a249-c57cc5a7cb9e",
        "storage_key": "property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe0h9nvbdQIYR4gPnqslCKOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_43f96a378b3650671f9e26ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Saldivia's South American Grill",
      "poi_type": "Restaurants",
      "poi_address": "10850 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Unassuming, family-run venue for Argentinian & Uruguayan specialties such as grilled meats & fish.",
      "poi_long_description": "Unassuming, family-run venue for Argentinian & Uruguayan specialties such as grilled meats & fish.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-c9d3-71af-8558-6d83cc40fd5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-c9d3-71af-8558-6d83cc40fd5a",
        "storage_key": "property/5759777107869696/019f1508-c9d3-71af-8558-6d83cc40fd5a.webp",
        "width": 1125,
        "height": 675
      },
      "poi_business_url": "http://www.saldivias.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16255074718745092536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saldivias-south-american-grill",
      "poi_latitude": "29.7379279",
      "poi_longitude": "-95.5678246",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-782-9494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d5-701b-a249-c57cc5a7cb9e",
        "storage_key": "property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1TI34TbDQIYRuOE7aFWgleE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_b6489f245dfd917b1bb3b601",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Ragin' Cajun",
      "poi_type": "Restaurants",
      "poi_address": "4302 Richmond Ave, Houston, TX 77027, USA",
      "poi_short_description": "An outpost of a casual Louisiana-style chain serving Cajun boiled & fried seafood, po' boys & more.",
      "poi_long_description": "An outpost of a casual Louisiana-style chain serving Cajun boiled & fried seafood, po' boys & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-dece-76be-9779-9c6037d45515.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-dece-76be-9779-9c6037d45515",
        "storage_key": "property/5759777107869696/019f1508-dece-76be-9779-9c6037d45515.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ragin-cajun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16174797005797542521&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ragin-cajun",
      "poi_latitude": "29.7328693",
      "poi_longitude": "-95.4490477",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 713-623-6321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d5-701b-a249-c57cc5a7cb9e",
        "storage_key": "property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU-QWTQ7BQIYReUqd1C1seOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "ec_90af8cdf20cee73f770aa910",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Dakar Street Food",
      "poi_type": "Restaurants",
      "poi_address": "2923 Walnut Bend Ln, Houston, TX 77042, USA",
      "poi_short_description": "Casual, Senegalese spot specializing in regional specialties such as rice and lamb dishes served with various sauces.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-cc72-74fb-9dc0-5e10608c88ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-cc72-74fb-9dc0-5e10608c88ac",
        "storage_key": "property/5759777107869696/019f1508-cc72-74fb-9dc0-5e10608c88ac.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "https://dakarstreetfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18360746553509322267&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dakar-street-food",
      "poi_latitude": "29.7319017",
      "poi_longitude": "-95.5672003",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-846-6420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d5-701b-a249-c57cc5a7cb9e",
        "storage_key": "property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5XGosm3dQIYRG57mBLZ5zv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_8f377e4fbd01961eec52f557",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Cafe Tales Specialty Coffee",
      "poi_type": "Restaurants",
      "poi_address": "11195 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Casual coffee shop with a variety of brewing methods offering quick bites such as croissants.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-cb50-7191-b98c-b32f86435931.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-cb50-7191-b98c-b32f86435931",
        "storage_key": "property/5759777107869696/019f1508-cb50-7191-b98c-b32f86435931.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://cafetalespecialty.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6861613865694612329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cafe-tales-specialty-coffee",
      "poi_latitude": "29.7361783",
      "poi_longitude": "-95.5729785",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 346-521-1050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-8a42-77b2-a49d-34d1af3604ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-8a42-77b2-a49d-34d1af3604ac",
        "storage_key": "property/5759777107869696/019f1509-8a42-77b2-a49d-34d1af3604ac.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJMRQRLADdQIYRaUuf2nRZOV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_177d6eb948addfedd06ea80d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Becks Prime",
      "poi_type": "Restaurants",
      "poi_address": "2615 Augusta Dr, Houston, TX 77057, USA",
      "poi_short_description": "Counter-service chain offering burgers, sandwiches & steaks grilled to order over mesquite coals.",
      "poi_long_description": "Counter-service chain offering burgers, sandwiches & steaks grilled to order over mesquite coals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-e048-750f-bb70-d2cdbed91293.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-e048-750f-bb70-d2cdbed91293",
        "storage_key": "property/5759777107869696/019f1508-e048-750f-bb70-d2cdbed91293.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.becksprime.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16502850154980222755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "becks-prime",
      "poi_latitude": "29.7387726",
      "poi_longitude": "-95.4821621",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 713-266-9901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d5-701b-a249-c57cc5a7cb9e",
        "storage_key": "property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyehYUtnDQIYRI6cYtcfmBeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_76afd94e60b12416a1d0299d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Moderno",
      "poi_type": "Restaurants",
      "poi_address": "10455 Briar Forest Dr Ste 150, Houston, TX 77042, USA",
      "poi_short_description": "Classic Tex-Mex & Mexican street eats alongside top-shelf tequila & craft beer in a cheerful space.",
      "poi_long_description": "Classic Tex-Mex & Mexican street eats alongside top-shelf tequila & craft beer in a cheerful space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-e4aa-743b-91f3-279d9f0b8597.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-e4aa-743b-91f3-279d9f0b8597",
        "storage_key": "property/5759777107869696/019f1508-e4aa-743b-91f3-279d9f0b8597.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.motacos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13824639221286605092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moderno",
      "poi_latitude": "29.7469573",
      "poi_longitude": "-95.5598",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-784-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d5-701b-a249-c57cc5a7cb9e",
        "storage_key": "property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8-GcZUvDQIYRJJG4LCD82r8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "ec_afd7c27c5536b291f4de52eb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Kasra Persian Grill",
      "poi_type": "Restaurants",
      "poi_address": "9741 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Modest family-run spot hidden in a strip mall serves large portions of homey Middle Eastern cuisine.",
      "poi_long_description": "Modest family-run spot hidden in a strip mall serves large portions of homey Middle Eastern cuisine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-e7cf-71dd-97ae-57b92db1dba7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-e7cf-71dd-97ae-57b92db1dba7",
        "storage_key": "property/5759777107869696/019f1508-e7cf-71dd-97ae-57b92db1dba7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.kasrarestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1850883766217975803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kasra-persian-grill",
      "poi_latitude": "29.736085",
      "poi_longitude": "-95.540949",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 713-975-1810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d5-701b-a249-c57cc5a7cb9e",
        "storage_key": "property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx9GB-T3DQIYR-6f1nfqorxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "persian_restaurant"
    },
    {
      "id": "ec_f5b73f94c4e0540d190a0696",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Torchy's Tacos",
      "poi_type": "Restaurants",
      "poi_address": "2675 Wilcrest Dr, Houston, TX 77042, USA",
      "poi_short_description": "Buzzy chain serving Mexican street-food-style tacos in inventive varieties, including for breakfast.",
      "poi_long_description": "Buzzy chain serving Mexican street-food-style tacos in inventive varieties, including for breakfast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-f3cd-724a-8f54-15327a173d81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-f3cd-724a-8f54-15327a173d81",
        "storage_key": "property/5759777107869696/019f1508-f3cd-724a-8f54-15327a173d81.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://torchystacos.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=9523262126257258432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "torchys-tacos",
      "poi_latitude": "29.73511839999999",
      "poi_longitude": "-95.5712318",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-487-4991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d5-701b-a249-c57cc5a7cb9e",
        "storage_key": "property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ81otSc_cQIYRwL9-inJsKYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_b2cc54fe1ffa5c50bf2f5cf5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Lava Lounge",
      "poi_type": "Restaurants",
      "poi_address": "9705 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Mediterranean plates such as kebabs and shawarma fries served in a casual setting with hookah pipes, a kids' menu, and a playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-04fc-73db-a8d7-12b3bb1a82cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-04fc-73db-a8d7-12b3bb1a82cf",
        "storage_key": "property/5759777107869696/019f1509-04fc-73db-a8d7-12b3bb1a82cf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://lavaloungehouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17962991468569502511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lava-lounge",
      "poi_latitude": "29.7365642",
      "poi_longitude": "-95.5397376",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-417-3606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d5-701b-a249-c57cc5a7cb9e",
        "storage_key": "property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR1sRy83DQIYRLyN1k5FdSfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "ec_373b85a0dfbe81f7ae8e0418",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Mi Pueblito Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "9425 Richmond Ave, Houston, TX 77063, USA",
      "poi_short_description": "Comfy spot for traditional Colombian food served in generous portions plus live music on weekends.",
      "poi_long_description": "Comfy spot for traditional Colombian food served in generous portions plus live music on weekends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-fd31-750d-a05a-28e026f75078.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-fd31-750d-a05a-28e026f75078",
        "storage_key": "property/5759777107869696/019f1508-fd31-750d-a05a-28e026f75078.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.mipueblitohouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5748779339101356088&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-pueblito-restaurant",
      "poi_latitude": "29.7284738",
      "poi_longitude": "-95.5315866",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 713-334-4594",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d5-701b-a249-c57cc5a7cb9e",
        "storage_key": "property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD4sY1xrDQIYROMA9v1nEx08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "colombian_restaurant"
    },
    {
      "id": "ec_8cbaa81910700b5aeae0985c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "9919 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-ec15-76f8-b413-20cf50575dac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-ec15-76f8-b413-20cf50575dac",
        "storage_key": "property/5759777107869696/019f1508-ec15-76f8-b413-20cf50575dac.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/houston/elmside/034/00363?cid=loc_03400363_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11055500868287114152&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "29.7363167",
      "poi_longitude": "-95.5452526",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 713-532-5566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0205-757c-9129-b15e25842f57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0205-757c-9129-b15e25842f57",
        "storage_key": "property/5759777107869696/019f1505-0205-757c-9129-b15e25842f57.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_kj8TvDQIYRqKtGFHcHbZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_3732e2c673a34d2a2e4f1719",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "10801 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-f9fd-7379-82e7-ecc885f4118e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-f9fd-7379-82e7-ecc885f4118e",
        "storage_key": "property/5759777107869696/019f1508-f9fd-7379-82e7-ecc885f4118e.webp",
        "width": 1280,
        "height": 715
      },
      "poi_business_url": "https://www.target.com/sl/houston-westchase/75",
      "poi_directions_map_url": "https://maps.google.com/?cid=11990776882479516189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "29.7349897",
      "poi_longitude": "-95.5678231",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-782-9950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-021d-70a3-9f0d-9ed390262436.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-021d-70a3-9f0d-9ed390262436",
        "storage_key": "property/5759777107869696/019f1505-021d-70a3-9f0d-9ed390262436.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7XTKs87cQIYRHUoodQvMZ6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_e7e9545f467ab4f647725e26",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "11041 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-0886-722e-b347-efd6fec88317.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-0886-722e-b347-efd6fec88317",
        "storage_key": "property/5759777107869696/019f1509-0886-722e-b347-efd6fec88317.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/westchase?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=16452124438804102209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "29.7348965",
      "poi_longitude": "-95.5706292",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-784-7776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0205-757c-9129-b15e25842f57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0205-757c-9129-b15e25842f57",
        "storage_key": "property/5759777107869696/019f1505-0205-757c-9129-b15e25842f57.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbVjVG8bcQIYRQfxwjwKwUeQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_00031478ed06c54fd9e80344",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "11038 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-03dc-76da-bf2b-907b0530fd6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-03dc-76da-bf2b-907b0530fd6e",
        "storage_key": "property/5759777107869696/019f1509-03dc-76da-bf2b-907b0530fd6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-11038+westheimer+rd-houston-tx-77042/id=7251",
      "poi_directions_map_url": "https://maps.google.com/?cid=7195342549686459348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.7374267",
      "poi_longitude": "-95.5713322",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-789-4847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2XKJvsjcQIYR1JtQJ-392mM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_505eb59a30bbebc1f08b222e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "10801 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-fff7-76d3-83ba-c6855ecf3e93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-fff7-76d3-83ba-c6855ecf3e93",
        "storage_key": "property/5759777107869696/019f1508-fff7-76d3-83ba-c6855ecf3e93.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/houston-tx-pharmacies/10801-westheimer-rd-houston-tx-77042/storeid=16017?WT.mc_id=LS_GOOGLE_RX_16017",
      "poi_directions_map_url": "https://maps.google.com/?cid=7861612795573398770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.7349897",
      "poi_longitude": "-95.5678231",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-580-0178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-89f4-70fc-8dac-eeacb2cca28f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-89f4-70fc-8dac-eeacb2cca28f",
        "storage_key": "property/5759777107869696/019f1509-89f4-70fc-8dac-eeacb2cca28f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7XTKs87cQIYR8mzRWS8PGm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_8663f5fe01d0d57253627402",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "9525 Westheimer Rd, Houston, TX 77063, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-0ceb-71c4-a14a-8a8265faaa3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-0ceb-71c4-a14a-8a8265faaa3e",
        "storage_key": "property/5759777107869696/019f1509-0ceb-71c4-a14a-8a8265faaa3e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/tx/houston/9525-westheimer/fa94",
      "poi_directions_map_url": "https://maps.google.com/?cid=10789530273526308404&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "29.7361",
      "poi_longitude": "-95.5337",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0205-757c-9129-b15e25842f57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0205-757c-9129-b15e25842f57",
        "storage_key": "property/5759777107869696/019f1505-0205-757c-9129-b15e25842f57.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQZRyRTHDQIYRNN7bTp4cvJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_c30d131348f055fa6e1d7ee3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "10964 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1508-ff8a-760b-b8b0-9f415170fcf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-ff8a-760b-b8b0-9f415170fcf7",
        "storage_key": "property/5759777107869696/019f1508-ff8a-760b-b8b0-9f415170fcf7.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/tx/houston/10964-westheimer-road?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1028854446833221455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "29.7377559",
      "poi_longitude": "-95.5703113",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 346-613-1290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-021d-70a3-9f0d-9ed390262436.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-021d-70a3-9f0d-9ed390262436",
        "storage_key": "property/5759777107869696/019f1505-021d-70a3-9f0d-9ed390262436.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ95lv38jcQIYRTz8TFas5Rw4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_2bfc6defe79a2945f4cbd932",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "10750 Westview Dr, Houston, TX 77043, USA",
      "poi_short_description": "Grocery chain, plus a bakery, is the place to find home goods, electronics and clothing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-04ad-7158-b437-3af3cb5067de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-04ad-7158-b437-3af3cb5067de",
        "storage_key": "property/5759777107869696/019f1509-04ad-7158-b437-3af3cb5067de.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1409-houston-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=230646548376402082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "29.7932382",
      "poi_longitude": "-95.5646814",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-984-2773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-021d-70a3-9f0d-9ed390262436.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-021d-70a3-9f0d-9ed390262436",
        "storage_key": "property/5759777107869696/019f1505-021d-70a3-9f0d-9ed390262436.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJExv4hzTbQIYRojilUNBrMwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_db1bb71d25380d5aada5de06",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Chevron Gas Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "10414 Richmond Ave, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-081d-711e-a70b-0aa1e17dc54d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-081d-711e-a70b-0aa1e17dc54d",
        "storage_key": "property/5759777107869696/019f1509-081d-711e-a70b-0aa1e17dc54d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chevronwithtechron.com/station/10414-Richmond-Ave-Houston-TX-77042-id352451",
      "poi_directions_map_url": "https://maps.google.com/?cid=14365430150790988174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chevron-gas-station",
      "poi_latitude": "29.7279738",
      "poi_longitude": "-95.5586516",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-89f5-7340-a092-0814b0da1016.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-89f5-7340-a092-0814b0da1016",
        "storage_key": "property/5759777107869696/019f1509-89f5-7340-a092-0814b0da1016.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJb6Qcri3DQIYRjkGVX5xCXMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_2df99dfab6a7d2b64545d839",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "10945 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-0ce4-774f-a3ec-071723f11560.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-0ce4-774f-a3ec-071723f11560",
        "storage_key": "property/5759777107869696/019f1509-0ce4-774f-a3ec-071723f11560.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3150811096046670796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "29.7350945",
      "poi_longitude": "-95.5686605",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-974-0181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-021d-70a3-9f0d-9ed390262436.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-021d-70a3-9f0d-9ed390262436",
        "storage_key": "property/5759777107869696/019f1505-021d-70a3-9f0d-9ed390262436.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtfAeJMncQIYRzJM4hv_tuSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_0b85529838e81828ade05581",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Sneed Elementary School",
      "poi_type": "Education",
      "poi_address": "9855 Pagewood Ln, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://sneed.aliefisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18356224938724685907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sneed-elementary-school",
      "poi_latitude": "29.7247712",
      "poi_longitude": "-95.5447465",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 713-789-6979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-9fefefb8c2f5",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV1pReyHDQIYRU_jZiVNpvv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_de32f54b48f90eaa453aa173",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Collins Elementary School",
      "poi_type": "Education",
      "poi_address": "9829 Town Park Dr, Houston, TX 77036, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://collins.aliefisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15977264414726850987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "collins-elementary-school",
      "poi_latitude": "29.7113632",
      "poi_longitude": "-95.5548828",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-272-3250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-9fefefb8c2f5",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPYSKPdHCQIYRq4lIglWlut0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_311d440e25a5c68c84f27178",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Walnut Bend Elementary School",
      "poi_type": "Education",
      "poi_address": "10620 Briar Forest Dr, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-113d-73ec-9f51-381549795e71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-113d-73ec-9f51-381549795e71",
        "storage_key": "property/5759777107869696/019f1509-113d-73ec-9f51-381549795e71.webp",
        "width": 1280,
        "height": 814
      },
      "poi_business_url": "https://www.houstonisd.org/walnutbendes",
      "poi_directions_map_url": "https://maps.google.com/?cid=17870822258916306062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walnut-bend-elementary-school",
      "poi_latitude": "29.7477325",
      "poi_longitude": "-95.5636522",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-917-3540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-9fefefb8c2f5",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK0nKfLPcQIYRjqzZKinqAfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_9ff584a2bdd2ace4b77cd486",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "River Oaks Academy",
      "poi_type": "Education",
      "poi_address": "10600 Richmond Ave, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.riveroaksacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6363708672694808424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-oaks-academy",
      "poi_latitude": "29.7284649",
      "poi_longitude": "-95.5631749",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 713-783-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-9fefefb8c2f5",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqUvl6tLcQIYRaO8LSlJvUFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_8f784a8a0fd665eaad8219b8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Westchase Neighborhood School",
      "poi_type": "Education",
      "poi_address": "10570 Westpark Dr, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-1380-7004-ae52-b4dafe87b724.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-1380-7004-ae52-b4dafe87b724",
        "storage_key": "property/5759777107869696/019f1509-1380-7004-ae52-b4dafe87b724.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.westchaseneighborhood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3611448197932693717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westchase-neighborhood-school",
      "poi_latitude": "29.7237676",
      "poi_longitude": "-95.5552948",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-968-6835",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-9fefefb8c2f5",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO7Lh8bTDQIYR1biAcgBxHjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_486727efd636739ac989763e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Primrose School of The Westchase District",
      "poi_type": "Education",
      "poi_address": "3191 Briarpark Dr, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-13f2-73c2-a796-9ca7ed4c49b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-13f2-73c2-a796-9ca7ed4c49b7",
        "storage_key": "property/5759777107869696/019f1509-13f2-73c2-a796-9ca7ed4c49b7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.primroseschools.com/schools/westchase-district/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=14246492622017909232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-the-westchase-district",
      "poi_latitude": "29.7307759",
      "poi_longitude": "-95.5480447",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-783-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-9fefefb8c2f5",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKY_tJSXDQIYR8NGZ_o61tcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_702871de191c5637aac4be1f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "ICC Mandarin Immersion Preschool & Elementary - 中華文化學院中英雙語幼兒園及小學",
      "poi_type": "Education",
      "poi_address": "10300 Westoffice Dr #200, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-13e1-772f-8684-013976a04a22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-13e1-772f-8684-013976a04a22",
        "storage_key": "property/5759777107869696/019f1509-13e1-772f-8684-013976a04a22.webp",
        "width": 810,
        "height": 1080
      },
      "poi_business_url": "http://www.iccschooltx.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1057909419178222371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "icc-mandarin-immersion-preschool--elementary---",
      "poi_latitude": "29.72110109999999",
      "poi_longitude": "-95.5495094",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 832-849-1509",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-9fefefb8c2f5",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf34Cr0XDQIYRI2Oo_gJzrg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_c2a6b592ce716922b5cafc37",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Westchase Academy & Daycare",
      "poi_type": "Education",
      "poi_address": "10085 Westpark Dr, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-295e-7029-9513-3c8489b7f0c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-295e-7029-9513-3c8489b7f0c1",
        "storage_key": "property/5759777107869696/019f1509-295e-7029-9513-3c8489b7f0c1.webp",
        "width": 1280,
        "height": 567
      },
      "poi_business_url": "http://westchaseacademydaycare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=98536654294868563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westchase-academy--daycare",
      "poi_latitude": "29.722525",
      "poi_longitude": "-95.544852",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 713-783-2520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-9fefefb8c2f5",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsRJ7ISHDQIYRU-KZpJASXgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_67e4218eeea81a7f1046eafc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Alief Early College High School",
      "poi_type": "Education",
      "poi_address": "2811 Hayes Rd, Houston, TX 77082, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-1da3-710b-ba97-67a56c14b045.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-1da3-710b-ba97-67a56c14b045",
        "storage_key": "property/5759777107869696/019f1509-1da3-710b-ba97-67a56c14b045.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://aechs.aliefisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13752786820980316568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alief-early-college-high-school",
      "poi_latitude": "29.7335587",
      "poi_longitude": "-95.5748878",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-988-3010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-9fefefb8c2f5",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB67ol8bcQIYRmJk0kL-2274",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_36c8756a0037c2941309630f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Houston Christian University",
      "poi_type": "Education",
      "poi_address": "7502 Fondren Rd, Houston, TX 77074, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1504-d7e7-736c-800f-ebfea8290d03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-d7e7-736c-800f-ebfea8290d03",
        "storage_key": "property/5759777107869696/019f1504-d7e7-736c-800f-ebfea8290d03.webp",
        "width": 1197,
        "height": 524
      },
      "poi_business_url": "https://hc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13811529488055007762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-christian-university",
      "poi_latitude": "29.6946466",
      "poi_longitude": "-95.5162157",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-9fefefb8c2f5",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo1jPUWfCQIYREvpZjORorL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_03147eadb99dcaa5ed64eb7e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Woodchase Park",
      "poi_type": "Entertainment",
      "poi_address": "3951 Woodchase Dr, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-1af0-723f-8e07-c5d97adde9c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-1af0-723f-8e07-c5d97adde9c4",
        "storage_key": "property/5759777107869696/019f1509-1af0-723f-8e07-c5d97adde9c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://woodchasepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11614271494229080655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodchase-park",
      "poi_latitude": "29.7205792",
      "poi_longitude": "-95.5438708",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 832-615-7303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0213-76a1-92ae-93f420341655",
        "storage_key": "property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCbjA84zDQIYRTzp4kmMuLqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b8247e8e5972e7859bddbdea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "IPIC Theaters",
      "poi_type": "Entertainment",
      "poi_address": "4444 Westheimer Rd, Houston, TX 77027, USA",
      "poi_short_description": "Upscale cinema chain with plush seating, gourmet light bites & cocktails, plus in-theater service.",
      "poi_long_description": "Upscale cinema chain with plush seating, gourmet light bites & cocktails, plus in-theater service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-1aeb-717d-a72a-3b7711e19b2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-1aeb-717d-a72a-3b7711e19b2b",
        "storage_key": "property/5759777107869696/019f1509-1aeb-717d-a72a-3b7711e19b2b.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.ipic.com/houston-tx-river-oaks/location?utm_source=google&utm_medium=local_listings&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=14365748038518097465&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ipic-theaters",
      "poi_latitude": "29.7432276",
      "poi_longitude": "-95.4530464",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 832-709-2146",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-89d8-70c4-bae7-2670f758c685.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-89d8-70c4-bae7-2670f758c685",
        "storage_key": "property/5759777107869696/019f1509-89d8-70c4-bae7-2670f758c685.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJlw8ARBTBQIYROcaiYLpjXcc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_a29d003d2bf71b6ef6a08e24",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "The River Oaks Theatre",
      "poi_type": "Entertainment",
      "poi_address": "2009 W Gray St, Houston, TX 77019, USA",
      "poi_short_description": "Retro theater with comfy seats, a bar and a snack kiosk, screening art-house films.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-1f2e-73b0-8304-65b7427365c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-1f2e-73b0-8304-65b7427365c4",
        "storage_key": "property/5759777107869696/019f1509-1f2e-73b0-8304-65b7427365c4.webp",
        "width": 850,
        "height": 315
      },
      "poi_business_url": "https://www.theriveroakstheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=790177706486962063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-river-oaks-theatre",
      "poi_latitude": "29.7526485",
      "poi_longitude": "-95.4091314",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 713-496-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-89d8-70c4-bae7-2670f758c685.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-89d8-70c4-bae7-2670f758c685",
        "storage_key": "property/5759777107869696/019f1509-89d8-70c4-bae7-2670f758c685.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJha2IEbzAQIYRj5eWAHBG9wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_809521375e3d9555f534e9cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "The Menil Collection",
      "poi_type": "Entertainment",
      "poi_address": "1533 Sul Ross St, Houston, TX 77006, USA",
      "poi_short_description": "Nearly 19,000 pieces of art & artifacts from the Paleolithic era to the present in a historic space.",
      "poi_long_description": "Nearly 19,000 pieces of art & artifacts from the Paleolithic era to the present in a historic space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-2837-76db-9298-5c664632b40a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-2837-76db-9298-5c664632b40a",
        "storage_key": "property/5759777107869696/019f1509-2837-76db-9298-5c664632b40a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.menil.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10144292371828842427&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-menil-collection",
      "poi_latitude": "29.7376565",
      "poi_longitude": "-95.398511",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 713-525-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-999cf7614339.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-999cf7614339",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-999cf7614339.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJJzfbZH-_QIYRux-QWCrEx4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_29cee043f672bf83cc72e965",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Rothko Chapel",
      "poi_type": "Entertainment",
      "poi_address": "3900 Yupon St, Houston, TX 77006, USA",
      "poi_short_description": "Historic octagonal brick building with massive abstract murals by Mark Rothko & outdoor sculptures.",
      "poi_long_description": "Historic octagonal brick building with massive abstract murals by Mark Rothko & outdoor sculptures.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-2ee5-723e-bc27-74152ecf6ab5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-2ee5-723e-bc27-74152ecf6ab5",
        "storage_key": "property/5759777107869696/019f1509-2ee5-723e-bc27-74152ecf6ab5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rothkochapel.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14931476464227924413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rothko-chapel",
      "poi_latitude": "29.737615",
      "poi_longitude": "-95.396166",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 713-524-9839",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwwhLJ3AQIYRvTlp3rtCN88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_landmark"
    },
    {
      "id": "ec_5e45c4dcfff12f41cf62beba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "The Museum of Fine Arts, Houston",
      "poi_type": "Entertainment",
      "poi_address": "1001 Bissonnet St, Houston, TX 77005, USA",
      "poi_short_description": "Distinct campus & sculpture garden with notable art from antiquity to today, plus films & programs.",
      "poi_long_description": "Distinct campus & sculpture garden with notable art from antiquity to today, plus films & programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-218b-708b-9c57-1991f495cd89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-218b-708b-9c57-1991f495cd89",
        "storage_key": "property/5759777107869696/019f1509-218b-708b-9c57-1991f495cd89.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.mfah.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12856993702091728189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-museum-of-fine-arts-houston",
      "poi_latitude": "29.7256229",
      "poi_longitude": "-95.3905328",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 713-639-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-999cf7614339.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-999cf7614339",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-999cf7614339.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJSx6QT3-_QIYRPaWcHKc3bbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_5e087ae3448b3f16066796dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Children's Museum Houston",
      "poi_type": "Entertainment",
      "poi_address": "1500 Binz St, Houston, TX 77004, USA",
      "poi_short_description": "Bustling family museum with a wealth of hands-on activities such as a Bubble Lab & a Tot Spot.",
      "poi_long_description": "Bustling family museum with a wealth of hands-on activities such as a Bubble Lab & a Tot Spot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-22c5-70a8-8cc4-ef1637b34ce7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-22c5-70a8-8cc4-ef1637b34ce7",
        "storage_key": "property/5759777107869696/019f1509-22c5-70a8-8cc4-ef1637b34ce7.webp",
        "width": 1280,
        "height": 873
      },
      "poi_business_url": "https://www.cmhouston.org/?utm_source=google&utm_medium=organic&utm_campaign=gmbhouston",
      "poi_directions_map_url": "https://maps.google.com/?cid=11886735036379074938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-museum-houston",
      "poi_latitude": "29.7229313",
      "poi_longitude": "-95.385289",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "4 hours 0 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 713-522-1138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-999cf7614339.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-999cf7614339",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-999cf7614339.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJoXCzG4O_QIYRepGQdokq9qQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_d7caa2a93d5e3013217d7b66",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Warehouse Live",
      "poi_type": "Entertainment",
      "poi_address": "2600 Travis St, Houston, TX 77006, USA",
      "poi_short_description": "Various music styles are showcased at this basic general-admission concert venue with a small bar.",
      "poi_long_description": "Various music styles are showcased at this basic general-admission concert venue with a small bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-22a9-75ba-bf72-b08453456577.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-22a9-75ba-bf72-b08453456577",
        "storage_key": "property/5759777107869696/019f1509-22a9-75ba-bf72-b08453456577.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.warehouselivemidtown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15344652098072076438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "warehouse-live",
      "poi_latitude": "29.7458262",
      "poi_longitude": "-95.3753559",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 832-767-0513",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7xypTCC_QIYRluCJo8gn89Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_212be70814dc46790746d282",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Echoes",
      "poi_type": "Entertainment",
      "poi_address": "900 Richmond Ave Ste A, Houston, TX 77006, USA",
      "poi_short_description": "Casual, indoor-outdoor venue for Greek-Mexican dishes alongside a slew of cocktails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-275d-751c-b74c-4fdd9a96dae0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-275d-751c-b74c-4fdd9a96dae0",
        "storage_key": "property/5759777107869696/019f1509-275d-751c-b74c-4fdd9a96dae0.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.echoeshtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17162019239168426760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "echoes",
      "poi_latitude": "29.7347815",
      "poi_longitude": "-95.3901198",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 713-497-5204",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d5-701b-a249-c57cc5a7cb9e",
        "storage_key": "property/5759777107869696/019f1505-01d5-701b-a249-c57cc5a7cb9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5_VCkya_QIYRCMMN25G9K-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "ec_114bb0ce5488cc0c01a321a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "House of Blues Houston",
      "poi_type": "Entertainment",
      "poi_address": "1204 Caroline St, Houston, TX 77002, USA",
      "poi_short_description": "Rock- & blues-themed restaurant & bar serving Southern-inspired dishes, plus live music.",
      "poi_long_description": "Rock- & blues-themed restaurant & bar serving Southern-inspired dishes, plus live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-2970-71cd-a956-9310186fb70d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-2970-71cd-a956-9310186fb70d",
        "storage_key": "property/5759777107869696/019f1509-2970-71cd-a956-9310186fb70d.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://houston.houseofblues.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=9767993603799322065&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "house-of-blues-houston",
      "poi_latitude": "29.7538217",
      "poi_longitude": "-95.3639531",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 32 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 713-652-5837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQDR6zy_QIYR0Q2_-m3ijoc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_3410738653474ffa312223fb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "HCA Houston ER 24/7 - Westchase",
      "poi_type": "Health and Wellness",
      "poi_address": "11103 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-2777-70b7-ba77-0866d87f4c47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-2777-70b7-ba77-0866d87f4c47",
        "storage_key": "property/5759777107869696/019f1509-2777-70b7-ba77-0866d87f4c47.webp",
        "width": 617,
        "height": 347
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/hca-houston-er-24-7-westchase?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11259115014254944631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-er-247---westchase",
      "poi_latitude": "29.7363082",
      "poi_longitude": "-95.5721252",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 832-708-3651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjaObMQfdQIYRd-HuvXNpQJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_1c5ba877e6dd785107de9eed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "HCA Houston Healthcare West",
      "poi_type": "Health and Wellness",
      "poi_address": "12141 Richmond Ave, Houston, TX 77082, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1504-ed0e-71ed-848c-bdf248ccc19b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-ed0e-71ed-848c-bdf248ccc19b",
        "storage_key": "property/5759777107869696/019f1504-ed0e-71ed-848c-bdf248ccc19b.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/west?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=266204689841745394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-west",
      "poi_latitude": "29.7288209",
      "poi_longitude": "-95.5942013",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-558-3444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d6-7493-919d-159e4dfa92cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d6-7493-919d-159e4dfa92cb",
        "storage_key": "property/5759777107869696/019f1505-01d6-7493-919d-159e4dfa92cb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5byGn_rcQIYR8m2PR8G_sQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_2d9634b7d47092e5b7f121b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Memorial Hermann Southwest Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "7600 Beechnut St, Houston, TX 77074, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1504-ebd1-730e-bf94-68ca009ed7d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-ebd1-730e-bf94-68ca009ed7d9",
        "storage_key": "property/5759777107869696/019f1504-ebd1-730e-bf94-68ca009ed7d9.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://memorialhermann.org/locations/southwest?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=4615674855845486349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-southwest-hospital",
      "poi_latitude": "29.692891",
      "poi_longitude": "-95.5212694",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-456-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d6-7493-919d-159e4dfa92cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d6-7493-919d-159e4dfa92cb",
        "storage_key": "property/5759777107869696/019f1505-01d6-7493-919d-159e4dfa92cb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aSzG4zCQIYRDV9fldMrDkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_351d998288a90377c30e2e36",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Memorial Hermann-GoHealth Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "11700 Westheimer Rd Ste j, Houston, TX 77077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-2f49-710e-a958-a15516e391c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-2f49-710e-a958-a15516e391c1",
        "storage_key": "property/5759777107869696/019f1509-2f49-710e-a958-a15516e391c1.webp",
        "width": 636,
        "height": 757
      },
      "poi_business_url": "https://www.gohealthuc.com/memorialhermann/locations/royal-oaks-centre?utm_source=gmb&utm_medium=organic&utm_content=memorialhermann-royaloakscentre",
      "poi_directions_map_url": "https://maps.google.com/?cid=4972540115267109553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-gohealth-urgent-care",
      "poi_latitude": "29.7372554",
      "poi_longitude": "-95.5842518",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 346-575-0067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGRGL3WPdQIYRsULgoeMCAkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_af12516cbc72000dce8e3975",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Kelsey-Seybold Clinic | Westchase",
      "poi_type": "Health and Wellness",
      "poi_address": "11284 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-3b5e-71e5-bda5-3b82d4ec3699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-3b5e-71e5-bda5-3b82d4ec3699",
        "storage_key": "property/5759777107869696/019f1509-3b5e-71e5-bda5-3b82d4ec3699.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.kelsey-seybold.com/find-a-location/westchase-clinic?utm_source=googlemybusiness&utm_medium=backlink&utm_campaign=location&eid=200000410&cid=googlemybusiness_backlink_location_200000410",
      "poi_directions_map_url": "https://maps.google.com/?cid=3410292602054552000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kelsey-seybold-clinic--westchase",
      "poi_latitude": "29.737185",
      "poi_longitude": "-95.5750728",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-442-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9aoBq3bdQIYRwKmalQ3LUy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "ec_b1054e1da3469612270984bf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "11112 Richmond Ave, Houston, TX 77042, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-3c2b-71c4-856e-760b7ed1ae40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-3c2b-71c4-856e-760b7ed1ae40",
        "storage_key": "property/5759777107869696/019f1509-3c2b-71c4-856e-760b7ed1ae40.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/houston-tx-pharmacies/11112-richmond-ave-corner-of-wilcrest-houston-tx-77042/storeid=3181?WT.mc_id=LS_GOOGLE_FS_3181",
      "poi_directions_map_url": "https://maps.google.com/?cid=13664924741312014372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "29.7281823",
      "poi_longitude": "-95.5710168",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 800-746-7287",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcUJcQtDcQIYRJGhZAKeQo70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_d5fa73934cc5eae5fd3a6991",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "11038 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-03dc-76da-bf2b-907b0530fd6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-03dc-76da-bf2b-907b0530fd6e",
        "storage_key": "property/5759777107869696/019f1509-03dc-76da-bf2b-907b0530fd6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-11038+westheimer+rd-houston-tx-77042/id=7251",
      "poi_directions_map_url": "https://maps.google.com/?cid=7195342549686459348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.7374267",
      "poi_longitude": "-95.5713322",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-789-4847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2XKJvsjcQIYR1JtQJ-392mM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_d019e888a0c59ff2fcea7d2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10770 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1504-e8d3-73bb-b19a-6b7ef6c5b4eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-e8d3-73bb-b19a-6b7ef6c5b4eb",
        "storage_key": "property/5759777107869696/019f1504-e8d3-73bb-b19a-6b7ef6c5b4eb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/houston-westchase-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12212685552691916244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "29.7377373",
      "poi_longitude": "-95.5660911",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-359-0012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtWMIfELdQIYR1C2_-c0sfKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_b99fe9873e6c47dfe0047d2b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "TITLE Boxing Club",
      "poi_type": "Health and Wellness",
      "poi_address": "9630 Westheimer Rd #600, Houston, TX 77063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-3e12-766c-af61-ea176c53afb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-3e12-766c-af61-ea176c53afb0",
        "storage_key": "property/5759777107869696/019f1509-3e12-766c-af61-ea176c53afb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://titleboxingclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7363532875081260336&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "title-boxing-club",
      "poi_latitude": "29.7385648",
      "poi_longitude": "-95.5358931",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-637-4246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-9fefefb8c2f5",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2UUjLD7DQIYRMB0h3yKGMGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_coaching"
    },
    {
      "id": "ec_1842fad21bbb2ded7ea1f007",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "HOTWORX- Houston, TX - Westchase",
      "poi_type": "Health and Wellness",
      "poi_address": "2687 Wilcrest Dr, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-39d7-7591-97d8-9cec428c0496.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-39d7-7591-97d8-9cec428c0496",
        "storage_key": "property/5759777107869696/019f1509-39d7-7591-97d8-9cec428c0496.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.hotworx.net/studio/houston-westchase?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=16856899996511335305&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx--houston-tx---westchase",
      "poi_latitude": "29.7346997",
      "poi_longitude": "-95.5712338",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 832-995-1146",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-9fefefb8c2f5",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz8_Ps6LdQIYRiXNXMjy97-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_bf21793db770f44eb9452c15",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Camden Park Westchase",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2951 Wilcrest Dr, Houston, TX 77042, USA",
      "poi_short_description": "Popular park featuring a splash pad, dog parks and a playground for kids.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1504-eec5-77be-8f36-0916d6c84951.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-eec5-77be-8f36-0916d6c84951",
        "storage_key": "property/5759777107869696/019f1504-eec5-77be-8f36-0916d6c84951.webp",
        "width": 1280,
        "height": 714
      },
      "poi_business_url": "https://camdenparkwestchase.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7949308463253431202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camden-park-westchase",
      "poi_latitude": "29.729676",
      "poi_longitude": "-95.5707528",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-780-9434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0213-76a1-92ae-93f420341655",
        "storage_key": "property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMVhvDqDdQIYRoiM6Gu6dUW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_acf826e7da3660a1a11beb3f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Woodchase Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3951 Woodchase Dr, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-1af0-723f-8e07-c5d97adde9c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-1af0-723f-8e07-c5d97adde9c4",
        "storage_key": "property/5759777107869696/019f1509-1af0-723f-8e07-c5d97adde9c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://woodchasepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11614271494229080655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodchase-park",
      "poi_latitude": "29.7205792",
      "poi_longitude": "-95.5438708",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 832-615-7303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0213-76a1-92ae-93f420341655",
        "storage_key": "property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCbjA84zDQIYRTzp4kmMuLqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_224cc79586fbbd0b52a25f45",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Sneed Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9855 Pagewood Ln, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-4c2e-74cc-ae78-3bd170156b5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-4c2e-74cc-ae78-3bd170156b5a",
        "storage_key": "property/5759777107869696/019f1509-4c2e-74cc-ae78-3bd170156b5a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.westchasedistrict.com/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14167834223065610971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sneed-dog-park",
      "poi_latitude": "29.7251893",
      "poi_longitude": "-95.5423916",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0213-76a1-92ae-93f420341655",
        "storage_key": "property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJob6sSmHDQIYR27pyVilCnsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_32a743703818b87d8a931e05",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Kirkwood Landing Apartments",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9850 S Kirkwood Rd, Houston, TX 77099, USA",
      "poi_short_description": "Apartment complex attracting good reviews for its cleanliness, friendly staff, and prompt maintenance.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-4272-70b1-aa3a-83097ec479c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-4272-70b1-aa3a-83097ec479c2",
        "storage_key": "property/5759777107869696/019f1509-4272-70b1-aa3a-83097ec479c2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.elandiskirkwood.com/?rcstdid=Mg%3D%3D-YRjTEizZPgM%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7219033312082907775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kirkwood-landing-apartments",
      "poi_latitude": "29.6714904",
      "poi_longitude": "-95.5883481",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 346-488-6738",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzz8YdKvdQIYRf9JpnIwoL2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "real_estate_agency"
    },
    {
      "id": "ec_9efc48f83b4298731f96121e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Tanglewilde Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9631 Windswept Ln, Houston, TX 77063, USA",
      "poi_short_description": "Park with a playground, ball field, fitness trail, tennis courts & picnic shelters on 4.6 acres.",
      "poi_long_description": "Park with a playground, ball field, fitness trail, tennis courts & picnic shelters on 4.6 acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-4835-76cf-a6c8-4331ba58f5c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-4835-76cf-a6c8-4331ba58f5c2",
        "storage_key": "property/5759777107869696/019f1509-4835-76cf-a6c8-4331ba58f5c2.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2126018614866988657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tanglewilde-park",
      "poi_latitude": "29.7244102",
      "poi_longitude": "-95.5374311",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 832-395-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0213-76a1-92ae-93f420341655",
        "storage_key": "property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ12r-3B7DQIYRcc4DhaoigR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7095d9b70befaeafa527930a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Walnut Bend Recreation Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10601 Briar Forest Dr, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-484d-728f-819b-95b8a292ef76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-484d-728f-819b-95b8a292ef76",
        "storage_key": "property/5759777107869696/019f1509-484d-728f-819b-95b8a292ef76.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walnutbend.org/amenities/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13222518171934824503&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walnut-bend-recreation-center",
      "poi_latitude": "29.74650979999999",
      "poi_longitude": "-95.5628847",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-781-2885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf6VWvLTcQIYRN5hSsjjSf7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_e126c67ec4cd40994f20d86f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Briarmeadow Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7703 Richmond Ave, Houston, TX 77063, USA",
      "poi_short_description": "Popular, neighborhood park featuring 2 playgrounds, tennis courts, picnic areas & open green space.",
      "poi_long_description": "Popular, neighborhood park featuring 2 playgrounds, tennis courts, picnic areas & open green space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-56ab-70e4-a898-8a526bf62918.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-56ab-70e4-a898-8a526bf62918",
        "storage_key": "property/5759777107869696/019f1509-56ab-70e4-a898-8a526bf62918.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.houstontx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=218440200943325331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "briarmeadow-park",
      "poi_latitude": "29.7307118",
      "poi_longitude": "-95.5040686",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 832-395-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0213-76a1-92ae-93f420341655",
        "storage_key": "property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz1Nf1rDDQIYRk1DklTQOCAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2328b72307c1a1321c31d747",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Harwin Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11305 Harwin Dr., Houston, TX 77072, USA",
      "poi_short_description": "Scenic park for picnics and strolls, with a trail for biking and running, plus a kids' play area.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-553d-74a0-9502-46dd0246fa14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-553d-74a0-9502-46dd0246fa14",
        "storage_key": "property/5759777107869696/019f1509-553d-74a0-9502-46dd0246fa14.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.houstontx.gov/parks/pdfs/FreeSpeechArea/Harwin%20Park.pdf",
      "poi_directions_map_url": "https://maps.google.com/?cid=236851159393585051&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harwin-park",
      "poi_latitude": "29.71506",
      "poi_longitude": "-95.5680431",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 832-395-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0213-76a1-92ae-93f420341655",
        "storage_key": "property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJY9aEcCndQIYRm0dL5N92SQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0cf8c37cdf5e36702c3786de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Vietnam Veterans Memorial City of Houston",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9680 Club Creek Dr, Houston, TX 77036, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-5c7d-748c-87e3-d9bf06887789.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-5c7d-748c-87e3-d9bf06887789",
        "storage_key": "property/5759777107869696/019f1509-5c7d-748c-87e3-d9bf06887789.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17977365315809648213&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vietnam-veterans-memorial-city-of-houston",
      "poi_latitude": "29.6796938",
      "poi_longitude": "-95.5469272",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0213-76a1-92ae-93f420341655",
        "storage_key": "property/5759777107869696/019f1505-0213-76a1-92ae-93f420341655.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqxXZ64fDQIYRVR5DroFufPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_375ac74c914de9a231e4d3e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Richmond Ave @ Westchase Dr",
      "poi_type": "Transportation & Transit",
      "poi_address": "Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-4c7b-763e-84af-fe96f805b97d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-4c7b-763e-84af-fe96f805b97d",
        "storage_key": "property/5759777107869696/019f1509-4c7b-763e-84af-fe96f805b97d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13848414358090048519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-ave--westchase-dr",
      "poi_latitude": "29.72863",
      "poi_longitude": "-95.55068",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVfkVZSXDQIYRB2RglHxzL8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_7f4805f9433e5eb7770b8242",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Westchase Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "11050 Harwin Dr., Houston, TX 77072, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-6096-723c-97be-e329780ee6b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-6096-723c-97be-e329780ee6b1",
        "storage_key": "property/5759777107869696/019f1509-6096-723c-97be-e329780ee6b1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5396743279492684688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westchase-park-and-ride",
      "poi_latitude": "29.717204",
      "poi_longitude": "-95.5628297",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-8a32-707c-9c87-fc438a5fc59a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-8a32-707c-9c87-fc438a5fc59a",
        "storage_key": "property/5759777107869696/019f1509-8a32-707c-9c87-fc438a5fc59a.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJIX9fwSrdQIYRkFsjZmsV5Uo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_c0eb26cfb221e1bdf7d3cc21",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Gessner Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "9925 Westpark Dr, Houston, TX 77063, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-5654-76e1-883d-136fb90a6598.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-5654-76e1-883d-136fb90a6598",
        "storage_key": "property/5759777107869696/019f1509-5654-76e1-883d-136fb90a6598.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8759854959400057547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gessner-park-and-ride",
      "poi_latitude": "29.72044959999999",
      "poi_longitude": "-95.5374292",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-8a32-707c-9c87-fc438a5fc59a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-8a32-707c-9c87-fc438a5fc59a",
        "storage_key": "property/5759777107869696/019f1509-8a32-707c-9c87-fc438a5fc59a.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJYdfhzB_DQIYRy_r7gqxBkXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_10dfb64624479593a6ce6984",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Westpark/Lower Uptown Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5105 Westpark Dr, Houston, TX 77056, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-551c-736e-b98b-5706d22f444a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-551c-736e-b98b-5706d22f444a",
        "storage_key": "property/5759777107869696/019f1509-551c-736e-b98b-5706d22f444a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2350213791813892094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westparklower-uptown-transit-center",
      "poi_latitude": "29.72532499999999",
      "poi_longitude": "-95.4650342",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-8a32-707c-9c87-fc438a5fc59a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-8a32-707c-9c87-fc438a5fc59a",
        "storage_key": "property/5759777107869696/019f1509-8a32-707c-9c87-fc438a5fc59a.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJFUi1hV3BQIYR_ndK3_2inSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_bff09d35b4ea5ab5f209262c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Hillcroft METRO Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Houston, TX 77074, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9139043739511785172&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillcroft-metro-park-and-ride",
      "poi_latitude": "29.722588",
      "poi_longitude": "-95.49586",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc5pDIcvDQIYR1IZbQNxn1H4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_cd96fb3b1c4ee93daef911f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "S Gessner Rd @ Westpark Dr",
      "poi_type": "Transportation & Transit",
      "poi_address": "Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3051986389815390672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "s-gessner-rd--westpark-dr",
      "poi_latitude": "29.72266399999999",
      "poi_longitude": "-95.539285",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtzD6Ch_DQIYR0PFFkHPVWio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_931af0ca6c448470433573d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Houston Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "902 Washington Ave, Houston, TX 77002, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-6610-729c-a46b-3218bafb3a2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-6610-729c-a46b-3218bafb3a2d",
        "storage_key": "property/5759777107869696/019f1509-6610-729c-a46b-3218bafb3a2d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=HOS",
      "poi_directions_map_url": "https://maps.google.com/?cid=11885103972172913154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-station",
      "poi_latitude": "29.7674",
      "poi_longitude": "-95.3675056",
      "poi_miles_from_property": "12.6 mi",
      "poi_walking_minutes": "4 hours 46 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0Zm_jO_QIYRAlrzuxdf8KQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_4cd6b667453cdbe076cd326b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "George Bush Intercontinental Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2800 N Terminal Rd, Houston, TX 77032, USA",
      "poi_short_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_long_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-6bb5-71e3-aeb9-870ddf7a5b04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-6bb5-71e3-aeb9-870ddf7a5b04",
        "storage_key": "property/5759777107869696/019f1509-6bb5-71e3-aeb9-870ddf7a5b04.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fly2houston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11296915713098302001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-intercontinental-airport",
      "poi_latitude": "29.9931058",
      "poi_longitude": "-95.3416255",
      "poi_miles_from_property": "33.4 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "2 hours 56 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 281-230-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-8a33-7736-a047-8553340d898d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-8a33-7736-a047-8553340d898d",
        "storage_key": "property/5759777107869696/019f1509-8a33-7736-a047-8553340d898d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VD2SO0QIYRMcLAyPy0xpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_b74f8a00b415fce7f5d5bb30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Phillips 66",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2331 CityWest Blvd, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1504-f39a-77ce-b254-9ec3652a1ee5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-f39a-77ce-b254-9ec3652a1ee5",
        "storage_key": "property/5759777107869696/019f1504-f39a-77ce-b254-9ec3652a1ee5.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.phillips66.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15860930961646065326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phillips-66",
      "poi_latitude": "29.7405404",
      "poi_longitude": "-95.5609181",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZb3nsDrDQIYRrpbov6xYHdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_4cc9b3c867f15f8cae3c0d21",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Westchase Corporate Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10111 Richmond Ave #180, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-697a-730d-8797-142b0d1d3034.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-697a-730d-8797-142b0d1d3034",
        "storage_key": "property/5759777107869696/019f1509-697a-730d-8797-142b0d1d3034.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11908388802070023458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westchase-corporate-center",
      "poi_latitude": "29.7276535",
      "poi_longitude": "-95.5515289",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 713-789-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmcVRei_DQIYRIo2fqoUYQ6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_1cd2eb235a000b08d7fd4f89",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Norris Conference Centers - Houston/Westchase",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9990 Richmond Ave Building, Ste. 102, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-614a-739e-9c85-ddd825434eee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-614a-739e-9c85-ddd825434eee",
        "storage_key": "property/5759777107869696/019f1509-614a-739e-9c85-ddd825434eee.webp",
        "width": 1280,
        "height": 747
      },
      "poi_business_url": "http://www.norriscenters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12212602900949797402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "norris-conference-centers---houstonwestchase",
      "poi_latitude": "29.7293167",
      "poi_longitude": "-95.5481719",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 713-780-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw0Vj3CTDQIYRGooEHqLhe6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_a82ea89c142dab18351e9e04",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Ultrasound Associates USA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3535 Briarpark Dr Ste 101, Houston, TX 77042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://ultrasound-associates.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3123154354626070640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ultrasound-associates-usa",
      "poi_latitude": "29.726203",
      "poi_longitude": "-95.548183",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 713-434-6954",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnYDqNiTDQIYRcIgznlasVys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "ec_429b2a18b27370652daee6fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Memorial Hermann Memorial City Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "921 Gessner Rd, Houston, TX 77024, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-70eb-773b-b3f5-f73dc3561277.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-70eb-773b-b3f5-f73dc3561277",
        "storage_key": "property/5759777107869696/019f1509-70eb-773b-b3f5-f73dc3561277.webp",
        "width": 1004,
        "height": 1280
      },
      "poi_business_url": "https://memorialhermann.org/locations/memorial-city?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=7341386861309126237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-memorial-city-medical-center",
      "poi_latitude": "29.780343",
      "poi_longitude": "-95.5469103",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 713-242-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d6-7493-919d-159e4dfa92cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d6-7493-919d-159e4dfa92cb",
        "storage_key": "property/5759777107869696/019f1505-01d6-7493-919d-159e4dfa92cb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQQlc7zEQIYRXeYMO3TY4WU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_16a90f6eeac015d0d431545c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "The Galleria",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5085 Westheimer Rd, Houston, TX 77056, USA",
      "poi_short_description": "Bright center with a glass roof offers ice skating & cafes, plus electronics & department stores.",
      "poi_long_description": "Bright center with a glass roof offers ice skating & cafes, plus electronics & department stores.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1504-cfc8-73dd-8c45-db56456abd5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-cfc8-73dd-8c45-db56456abd5d",
        "storage_key": "property/5759777107869696/019f1504-cfc8-73dd-8c45-db56456abd5d.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.simon.com/mall/the-galleria",
      "poi_directions_map_url": "https://maps.google.com/?cid=9080376292649229487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-galleria",
      "poi_latitude": "29.7391955",
      "poi_longitude": "-95.4634342",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-622-0663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-021d-70a3-9f0d-9ed390262436.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-021d-70a3-9f0d-9ed390262436",
        "storage_key": "property/5759777107869696/019f1505-021d-70a3-9f0d-9ed390262436.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0b3z7m7BQIYRr1w81iD6A34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_66569309ebc4bcad804132cf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Williams Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2800 Post Oak Blvd, Houston, TX 77056, USA",
      "poi_short_description": "Soaring 64-story skyscraper featuring a modern design, and adjacent to a water wall park.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-7a3c-72ee-b58a-014890935169.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-7a3c-72ee-b58a-014890935169",
        "storage_key": "property/5759777107869696/019f1509-7a3c-72ee-b58a-014890935169.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.williamstower.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15170686362664397419&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williams-tower",
      "poi_latitude": "29.7372799",
      "poi_longitude": "-95.4616513",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMzyxy23BQIYRa2p5fd4aidI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_78057f3506dfccc56f847aa5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Central Park Post Oak",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1990 Post Oak Blvd, Houston, TX 77056, USA",
      "poi_short_description": "Manicured, 17-acre campus featuring Class A office space, retail outlets and a park with a ping-pong table.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-720f-73fc-bd84-63c92c8a3e74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-720f-73fc-bd84-63c92c8a3e74",
        "storage_key": "property/5759777107869696/019f1509-720f-73fc-bd84-63c92c8a3e74.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.centralparkpostoak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14416876782362370476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-park-post-oak",
      "poi_latitude": "29.7454463",
      "poi_longitude": "-95.4629171",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 713-871-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d4-76d3-a9dc-2d391de7ac59",
        "storage_key": "property/5759777107869696/019f1505-01d4-76d3-a9dc-2d391de7ac59.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX41F5GnBQIYRrCFJtwwJE8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_4f497bcf730d22292932560e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Houston Christian University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7502 Fondren Rd, Houston, TX 77074, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1504-d7e7-736c-800f-ebfea8290d03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1504-d7e7-736c-800f-ebfea8290d03",
        "storage_key": "property/5759777107869696/019f1504-d7e7-736c-800f-ebfea8290d03.webp",
        "width": 1197,
        "height": 524
      },
      "poi_business_url": "https://hc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13811529488055007762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-christian-university",
      "poi_latitude": "29.6946466",
      "poi_longitude": "-95.5162157",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-0224-7173-8858-9fefefb8c2f5",
        "storage_key": "property/5759777107869696/019f1505-0224-7173-8858-9fefefb8c2f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo1jPUWfCQIYREvpZjORorL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_4a1873890ad7010b12a0c964",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "poi_name": "Texas Children's Hospital West Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "18200 Katy Fwy, Houston, TX 77094, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1509-79c6-77d6-819f-f90f3ff761a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-79c6-77d6-819f-f90f3ff761a9",
        "storage_key": "property/5759777107869696/019f1509-79c6-77d6-819f-f90f3ff761a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texaschildrens.org/locations/texas-childrens-hospital/west-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=7901152811411417951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-childrens-hospital-west-campus",
      "poi_latitude": "29.78780029999999",
      "poi_longitude": "-95.6928635",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 28 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 832-227-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f1505-01d6-7493-919d-159e4dfa92cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-01d6-7493-919d-159e4dfa92cb",
        "storage_key": "property/5759777107869696/019f1505-01d6-7493-919d-159e4dfa92cb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJWxiVseHYQIYRX6tBsJ6Ipm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "custom_dea077b5-d3f0-4343-9518-644c163c83ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_fdae160e-235c-41de-ac8a-04d17956e095",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_ae1af926-409e-4fde-ad68-bad55e8d74f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_7f95d557-54da-4428-b2b6-b62efcb62683",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_6f13d314-0731-453c-ae2f-2ad239c92895",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_bf233e51-ed16-4ba6-ac1d-e53059ff2c88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_bbde4f7d-49fe-42e8-9aec-0ed793eb6101",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_a464ce7bf8a585539d986789",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "rating": "5",
      "name": "Meg Eldred",
      "text": "The entire process from beginning to move in, was very easy. Every lady in the office has been very helpful. The maintenance guys are very prompt and helpful as well. The property is kept clean. I had a little trouble filling my application out online, so the ladies in the office helped me figure it out. Everyone here has definitely gone above and beyond! 100% would recommend this place. The location is great & the people are amazing!",
      "date": "2026-02-25",
      "title": "false"
    },
    {
      "id": "ec_419c33654cba187d027d1484",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "rating": "5",
      "name": "Brigette Williams",
      "text": "The unit is spacious, with upgraded stainless steel appliances in the kitchen and a large balcony, which I did not have prior to moving here. The office staff is excellent; I had a minor issue that Sonya addressed professionally. I took responsibility for it, and she was very kind, firm, and understanding. Please feel free to communicate any concerns or needs to the office staff—being respectful and following the property rules is appreciated always at any property in the world.\n\nThe pool is open late and the gym is available 24 hours, which is a great convenience that I did not have previously. Maintenance services are very prompt and efficient; I often work with Abelino, who is always friendly, double-checks his work, and clearly explains what the issue was once completed.",
      "date": "2025-09-24",
      "title": "false"
    },
    {
      "id": "ec_09e917ffc31f9e602d8bd50b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "rating": "5",
      "name": "Javara West",
      "text": "I’ve been living here for a little over 3 years and I have no complaints. The community is quiet and I feel safe. Everyone on staff here is wonderful. Sonja made my transfer to a larger unit so easy & catered to my needs. She’s so easy to work with, communicates is such a timely manner and just a great person. Ashstin is a great manager & every interaction has always been a pleasant. The maintenance team is wonderful also. I’ve only had a few encounters with them and they are always prompt, professional, & friendly.",
      "date": "2025-04-17",
      "title": "false"
    },
    {
      "id": "ec_92a529d758a4002ec1702a19",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "rating": "5",
      "name": "Melissa Sanchez",
      "text": "I would definitely recommend living at Finley West! The staff are truly amazing! All of them Aurora, Ashstin & Sonja are the best. They definitely made my kids year full of happiness. I love everything about living here to the appliances, community and pool. Maintenance is awesome too! Safe area to live in. Thank you again Finley west team 😊",
      "date": "2025-08-26",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_7e353df1916c644cb96607bc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f14c4-1193-75ba-8b02-c41183bf9c6b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-1193-75ba-8b02-c41183bf9c6b",
        "storage_key": "property/5759777107869696/019f14c4-1193-75ba-8b02-c41183bf9c6b.webp",
        "width": 800,
        "height": 533
      },
      "virtual_tour_title": "2BR, 2BA - 1,046SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7x54AWqeqbf"
    },
    {
      "id": "ec_71437388fcb308cf501b9ee6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f14c4-1449-73e6-a82b-85d355bbc428.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-1449-73e6-a82b-85d355bbc428",
        "storage_key": "property/5759777107869696/019f14c4-1449-73e6-a82b-85d355bbc428.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Finley West",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/8vqu7Crm0HM?rel=0"
    },
    {
      "id": "ec_7f30a8e25d64fdf6a39f2b11",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f14c4-12c0-7201-b007-e2d3b43f21dd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-12c0-7201-b007-e2d3b43f21dd",
        "storage_key": "property/5759777107869696/019f14c4-12c0-7201-b007-e2d3b43f21dd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2 BR 2 BA - 1012SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eTQyX2hiUc6"
    },
    {
      "id": "ec_54f2457b4e8139e4ceafde68",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f14c4-1c1f-76e5-803f-0de6f9a157e2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-1c1f-76e5-803f-0de6f9a157e2",
        "storage_key": "property/5759777107869696/019f14c4-1c1f-76e5-803f-0de6f9a157e2.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=AKqmix4U9tx"
    },
    {
      "id": "ec_a8f906b0425f04962629e8d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f14c4-1da4-726b-a31f-10e51f97fb4f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-1da4-726b-a31f-10e51f97fb4f",
        "storage_key": "property/5759777107869696/019f14c4-1da4-726b-a31f-10e51f97fb4f.webp",
        "width": 800,
        "height": 533
      },
      "virtual_tour_title": "Strength and Cardio Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=zwkhKqVAKNa"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-88b5-7238-ac9f-76a2f4b5514b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "finley-west",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696"
    },
    {
      "lead_collector_id": "0198aa45-891b-725d-8576-9ce8eef1dbce",
      "lead_source": "FACEBOOK_ADS",
      "name": "finley-west",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696"
    },
    {
      "lead_collector_id": "0198aa45-897e-70d8-830d-a54fe2249d05",
      "lead_source": "LANDING_PAGE",
      "name": "finley-west",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "discover-one-bedroom-apartments-for-rent-houston-tx",
      "search_query": "One Bedroom Apartments For Rent In Houston TX",
      "category": "Floorplan",
      "h1_title": "Discover One Bedroom Apartments For Rent In Houston TX",
      "h2_subtitle": "Finley West offers a serene living experience with lush surroundings. Enjoy modern amenities and in-home features designed for your comfort and convenience.",
      "page_copy": "Finley West is your ideal destination for one bedroom apartments for rent in Houston TX. Nestled in a lush setting, our community offers a peaceful retreat with mature landscaping and a variety of amenities. Each apartment is equipped with air conditioning, multi-speed fans, and a wood-burning fireplace, ensuring a comfortable living environment. Enjoy the convenience of a private balcony or patio, perfect for relaxing after a long day.\n\nOur community features a resort-inspired swimming pool and a state-of-the-art fitness center, providing ample opportunities for recreation and wellness. Located in Harris County, Finley West is part of the Alief Independent attendance zone, making it a great choice for families. Managed by American Landmark, our community is committed to providing exceptional service and a welcoming atmosphere. Discover the perfect blend of comfort and convenience at Finley West.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | One Bedroom Apartments For Rent In Houston TX",
      "seo_description": "Explore Finley West's one bedroom apartments for rent in Houston TX. Enjoy lush surroundings, modern amenities, and a convenient location in Harris County.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "explore-two-bedrooms-apartments-for-rent-houston-tx",
      "search_query": "Two Bedrooms Apartments For Rent In Houston TX",
      "category": "Floorplan",
      "h1_title": "Explore Two Bedrooms Apartments For Rent In Houston TX",
      "h2_subtitle": "Finley West provides a tranquil living environment with lush greenery. Experience spacious living with modern amenities and thoughtful in-home features.",
      "page_copy": "Finley West is the perfect choice for those seeking two bedrooms apartments for rent in Houston TX. Our community is set amidst lush landscaping, offering a serene escape from the hustle and bustle of city life. Each apartment is thoughtfully designed with features like air conditioning, multi-speed fans, and a cozy wood-burning fireplace. Enjoy the luxury of a private balcony or patio, ideal for unwinding and enjoying the view.\n\nResidents of Finley West have access to a resort-inspired swimming pool and a comprehensive fitness center, catering to both strength and cardio workouts. Located in Harris County and part of the Alief Independent attendance zone, our community is managed by American Landmark, ensuring top-notch service and a welcoming atmosphere. Discover the spacious and comfortable living spaces at Finley West, where convenience meets tranquility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Two Bedrooms Apartments For Rent In Houston TX",
      "seo_description": "Discover Finley West's two bedrooms apartments for rent in Houston TX. Enjoy spacious living, modern amenities, and a serene environment in Harris County.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-pool-at-finley-west",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Pool at Finley West",
      "h2_subtitle": "Finley West offers a refreshing lifestyle with a resort-inspired pool. Enjoy modern living with exceptional amenities and lush surroundings in Houston.",
      "page_copy": "Discover the perfect apartments for rent near me with pool at Finley West, where luxury meets convenience. Our community is nestled in a lush setting, providing a serene environment with mature landscaping. Each apartment is designed with comfort in mind, featuring air conditioning, multi-speed fans, and a wood-burning fireplace. Enjoy the added benefit of a private balcony or patio, perfect for relaxing and enjoying the view.\n\nFinley West features a resort-inspired swimming pool, ideal for unwinding and enjoying sunny Houston days. Our community also includes a state-of-the-art fitness center, ensuring you have everything you need for a healthy lifestyle. Managed by American Landmark, Finley West is located in Harris County and serves the Alief Independent attendance zone. Experience the best of apartment living with exceptional amenities and a welcoming atmosphere at Finley West.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent Near Me with Pool",
      "seo_description": "Explore Finley West's apartments for rent near me with pool. Enjoy a resort-inspired pool, modern amenities, and lush surroundings in Houston.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "Finley West offers a vibrant lifestyle with a state-of-the-art fitness center. Enjoy modern amenities and lush surroundings in the heart of Houston.",
      "page_copy": "Explore the ideal apartments for rent near me with fitness center at Finley West, where convenience and luxury come together. Our community is set in a lush environment, providing a peaceful retreat with mature landscaping. Each apartment is equipped with modern features like air conditioning, multi-speed fans, and a cozy wood-burning fireplace. Relax on your private balcony or patio, perfect for enjoying the serene surroundings.\n\nFinley West features a comprehensive fitness center, catering to both strength and cardio workouts, ensuring you have everything you need to maintain a healthy lifestyle. Our community also includes a resort-inspired swimming pool, offering a perfect spot to unwind. Managed by American Landmark, Finley West is located in Harris County and serves the Alief Independent attendance zone. Experience exceptional apartment living with top-notch amenities and a welcoming atmosphere at Finley West.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Find Finley West's apartments for rent near me with fitness center. Enjoy a state-of-the-art fitness center, modern amenities, and lush surroundings in Houston.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-package-service",
      "search_query": "Apartments For Rent Near Me with Package Service",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Package Service",
      "h2_subtitle": "Finley West offers convenient living with a reliable package service. Enjoy modern amenities and lush surroundings in a prime Houston location.",
      "page_copy": "Discover the convenience of apartments for rent near me with package service at Finley West. Our community is nestled in a lush setting, providing a tranquil environment with mature landscaping. Each apartment is designed for comfort, featuring air conditioning, multi-speed fans, and a cozy wood-burning fireplace. Enjoy the luxury of a private balcony or patio, perfect for relaxing and taking in the view.\n\nFinley West features a reliable package service, ensuring your deliveries are handled with care and convenience. Our community also includes a resort-inspired swimming pool and a state-of-the-art fitness center, offering a complete lifestyle experience. Managed by American Landmark, Finley West is located in Harris County and serves the Alief Independent attendance zone. Experience the perfect blend of convenience and comfort with exceptional amenities at Finley West.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent Near Me with Package Service",
      "seo_description": "Explore Finley West's apartments for rent near me with package service. Enjoy convenient package handling, modern amenities, and lush surroundings in Houston.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-philips-medical",
      "search_query": "Apartments For Rent In Houston TX Near Philips Medical Services",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston TX Near Philips Medical Services",
      "h2_subtitle": "Finley West offers convenient living near Philips Medical Services. Enjoy modern amenities and lush surroundings in a prime Houston location.",
      "page_copy": "Explore the perfect apartments for rent in Houston TX near Philips Medical Services at Finley West. Our community is nestled in a lush setting, providing a serene environment with mature landscaping. Each apartment is designed for comfort, featuring air conditioning, multi-speed fans, and a cozy wood-burning fireplace. Enjoy the luxury of a private balcony or patio, perfect for relaxing and taking in the view.\n\nFinley West features a resort-inspired swimming pool and a state-of-the-art fitness center, offering a complete lifestyle experience. Managed by American Landmark, our community is located in Harris County and serves the Alief Independent attendance zone. With a focus on convenience and comfort, Finley West provides a welcoming atmosphere and exceptional amenities, making it the perfect place to call home near Philips Medical Services.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent In Houston TX Near Philips Medical Services",
      "seo_description": "Explore Finley West's apartments for rent in Houston TX near Philips Medical Services. Enjoy modern amenities and lush surroundings in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-houston-tx-near-hca-healthcare-west",
      "search_query": "Apartments For Rent In Houston TX Near HCA Houston Healthcare West",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston TX Near HCA Houston Healthcare West",
      "h2_subtitle": "Finley West offers convenient living near HCA Houston Healthcare West. Enjoy modern amenities and lush surroundings in a prime Houston location.",
      "page_copy": "Discover the ideal apartments for rent in Houston TX near HCA Houston Healthcare West at Finley West. Our community is nestled in a lush setting, providing a serene environment with mature landscaping. Each apartment is designed for comfort, featuring air conditioning, multi-speed fans, and a cozy wood-burning fireplace. Enjoy the luxury of a private balcony or patio, perfect for relaxing and taking in the view.\n\nFinley West features a resort-inspired swimming pool and a state-of-the-art fitness center, offering a complete lifestyle experience. Managed by American Landmark, our community is located in Harris County and serves the Alief Independent attendance zone. With a focus on convenience and comfort, Finley West provides a welcoming atmosphere and exceptional amenities, making it the perfect place to call home near HCA Houston Healthcare West.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent In Houston TX Near HCA Houston Healthcare West",
      "seo_description": "Explore Finley West's apartments for rent in Houston TX near HCA Houston Healthcare West. Enjoy modern amenities and lush surroundings in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-methodist-debakey",
      "search_query": "Apartments For Rent In Houston TX Near Methodist Debakey Heart Center",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston TX Near Methodist Debakey Heart Center",
      "h2_subtitle": "Finley West offers convenient living near Methodist Debakey Heart Center. Enjoy modern amenities and lush surroundings in a prime Houston location.",
      "page_copy": "Explore the perfect apartments for rent in Houston TX near Methodist Debakey Heart Center at Finley West. Our community is nestled in a lush setting, providing a serene environment with mature landscaping. Each apartment is designed for comfort, featuring air conditioning, multi-speed fans, and a cozy wood-burning fireplace. Enjoy the luxury of a private balcony or patio, perfect for relaxing and taking in the view.\n\nFinley West features a resort-inspired swimming pool and a state-of-the-art fitness center, offering a complete lifestyle experience. Managed by American Landmark, our community is located in Harris County and serves the Alief Independent attendance zone. With a focus on convenience and comfort, Finley West provides a welcoming atmosphere and exceptional amenities, making it the perfect place to call home near Methodist Debakey Heart Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent In Houston TX Near Methodist Debakey Heart Center",
      "seo_description": "Explore Finley West's apartments for rent in Houston TX near Methodist Debakey Heart Center. Enjoy modern amenities and lush surroundings in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-houston-tx-near-memorial-hermann",
      "search_query": "Apartments For Rent In Houston TX Near Memorial Hermann Southwest Hospital",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston TX Near Memorial Hermann Southwest Hospital",
      "h2_subtitle": "Finley West offers convenient living near Memorial Hermann Southwest Hospital. Enjoy modern amenities and lush surroundings in a prime Houston location.",
      "page_copy": "Discover the ideal apartments for rent in Houston TX near Memorial Hermann Southwest Hospital at Finley West. Our community is nestled in a lush setting, providing a serene environment with mature landscaping. Each apartment is designed for comfort, featuring air conditioning, multi-speed fans, and a cozy wood-burning fireplace. Enjoy the luxury of a private balcony or patio, perfect for relaxing and taking in the view.\n\nFinley West features a resort-inspired swimming pool and a state-of-the-art fitness center, offering a complete lifestyle experience. Managed by American Landmark, our community is located in Harris County and serves the Alief Independent attendance zone. With a focus on convenience and comfort, Finley West provides a welcoming atmosphere and exceptional amenities, making it the perfect place to call home near Memorial Hermann Southwest Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent In Houston TX Near Memorial Hermann Southwest Hospital",
      "seo_description": "Explore Finley West's apartments for rent in Houston TX near Memorial Hermann Southwest Hospital. Enjoy modern amenities and lush surroundings in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-tsu",
      "search_query": "Apartments For Rent In Houston TX Near Texas Southern University",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston TX Near Texas Southern University",
      "h2_subtitle": "Finley West offers convenient living near Texas Southern University. Enjoy modern amenities and lush surroundings in a prime Houston location.",
      "page_copy": "Explore the perfect apartments for rent in Houston TX near Texas Southern University at Finley West. Our community is nestled in a lush setting, providing a serene environment with mature landscaping. Each apartment is designed for comfort, featuring air conditioning, multi-speed fans, and a cozy wood-burning fireplace. Enjoy the luxury of a private balcony or patio, perfect for relaxing and taking in the view.\n\nFinley West features a resort-inspired swimming pool and a state-of-the-art fitness center, offering a complete lifestyle experience. Managed by American Landmark, our community is located in Harris County and serves the Alief Independent attendance zone. With a focus on convenience and comfort, Finley West provides a welcoming atmosphere and exceptional amenities, making it the perfect place to call home near Texas Southern University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent In Houston TX Near Texas Southern University",
      "seo_description": "Explore Finley West's apartments for rent in Houston TX near Texas Southern University. Enjoy modern amenities and lush surroundings in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-houston-tx-near-university-st-thomas",
      "search_query": "Apartments For Rent In Houston TX Near University of St. Thomas",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston TX Near University of St. Thomas",
      "h2_subtitle": "Finley West offers convenient living near University of St. Thomas. Enjoy modern amenities and lush surroundings in a prime Houston location.",
      "page_copy": "Discover the ideal apartments for rent in Houston TX near University of St. Thomas at Finley West. Our community is nestled in a lush setting, providing a serene environment with mature landscaping. Each apartment is designed for comfort, featuring air conditioning, multi-speed fans, and a cozy wood-burning fireplace. Enjoy the luxury of a private balcony or patio, perfect for relaxing and taking in the view.\n\nFinley West features a resort-inspired swimming pool and a state-of-the-art fitness center, offering a complete lifestyle experience. Managed by American Landmark, our community is located in Harris County and serves the Alief Independent attendance zone. With a focus on convenience and comfort, Finley West provides a welcoming atmosphere and exceptional amenities, making it the perfect place to call home near University of St. Thomas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent In Houston TX Near University of St. Thomas",
      "seo_description": "Explore Finley West's apartments for rent in Houston TX near University of St. Thomas. Enjoy modern amenities and lush surroundings in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-uhd",
      "search_query": "Apartments For Rent In Houston TX Near University of Houston-Downtown (UHD)",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston TX Near University of Houston-Downtown (UHD)",
      "h2_subtitle": "Finley West offers convenient living near University of Houston-Downtown (UHD). Enjoy modern amenities and lush surroundings in a prime Houston location.",
      "page_copy": "Explore the perfect apartments for rent in Houston TX near University of Houston-Downtown (UHD) at Finley West. Our community is nestled in a lush setting, providing a serene environment with mature landscaping. Each apartment is designed for comfort, featuring air conditioning, multi-speed fans, and a cozy wood-burning fireplace. Enjoy the luxury of a private balcony or patio, perfect for relaxing and taking in the view.\n\nFinley West features a resort-inspired swimming pool and a state-of-the-art fitness center, offering a complete lifestyle experience. Managed by American Landmark, our community is located in Harris County and serves the Alief Independent attendance zone. With a focus on convenience and comfort, Finley West provides a welcoming atmosphere and exceptional amenities, making it the perfect place to call home near University of Houston-Downtown (UHD).",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent In Houston TX Near University of Houston-Downtown (UHD)",
      "seo_description": "Explore Finley West's apartments for rent in Houston TX near University of Houston-Downtown (UHD). Enjoy modern amenities and lush surroundings in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-houston-community-college",
      "search_query": "Apartments For Rent In Houston TX Near Houston Community College - Stafford Campus",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston TX Near Houston Community College - Stafford Campus",
      "h2_subtitle": "Finley West offers convenient living near Houston Community College - Stafford Campus. Enjoy modern amenities and lush surroundings in a prime Houston location.",
      "page_copy": "Discover the ideal apartments for rent in Houston TX near Houston Community College - Stafford Campus at Finley West. Our community is nestled in a lush setting, providing a serene environment with mature landscaping. Each apartment is designed for comfort, featuring air conditioning, multi-speed fans, and a cozy wood-burning fireplace. Enjoy the luxury of a private balcony or patio, perfect for relaxing and taking in the view.\n\nFinley West features a resort-inspired swimming pool and a state-of-the-art fitness center, offering a complete lifestyle experience. Managed by American Landmark, our community is located in Harris County and serves the Alief Independent attendance zone. With a focus on convenience and comfort, Finley West provides a welcoming atmosphere and exceptional amenities, making it the perfect place to call home near Houston Community College - Stafford Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent In Houston TX Near Houston Community College - Stafford Campus",
      "seo_description": "Explore Finley West's apartments for rent in Houston TX near Houston Community College - Stafford Campus. Enjoy modern amenities and lush surroundings in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-near-uthealth",
      "search_query": "Apartments For Rent In Houston TX Near UTHealth Houston (The University of Texas Health Science Center at Houston)",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston TX Near UTHealth Houston",
      "h2_subtitle": "Finley West offers convenient living near UTHealth Houston. Enjoy modern amenities and lush surroundings in a prime Houston location.",
      "page_copy": "Explore the perfect apartments for rent in Houston TX near UTHealth Houston at Finley West. Our community is nestled in a lush setting, providing a serene environment with mature landscaping. Each apartment is designed for comfort, featuring air conditioning, multi-speed fans, and a cozy wood-burning fireplace. Enjoy the luxury of a private balcony or patio, perfect for relaxing and taking in the view.\n\nFinley West features a resort-inspired swimming pool and a state-of-the-art fitness center, offering a complete lifestyle experience. Managed by American Landmark, our community is located in Harris County and serves the Alief Independent attendance zone. With a focus on convenience and comfort, Finley West provides a welcoming atmosphere and exceptional amenities, making it the perfect place to call home near UTHealth Houston.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent In Houston TX Near UTHealth Houston",
      "seo_description": "Explore Finley West's apartments for rent in Houston TX near UTHealth Houston. Enjoy modern amenities and lush surroundings in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-houston-tx-near-alief-high-school",
      "search_query": "Apartments For Rent In Houston TX Near Alief Early College High School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston TX Near Alief Early College High School",
      "h2_subtitle": "Finley West offers family-friendly living just 3.5 km from Alief Early College High School. Enjoy spacious floor plans and modern amenities in a lush Houston setting.",
      "page_copy": "Discover the perfect apartments for rent in Houston TX near Alief Early College High School at Finley West. Located just 3.5 km away, our community is ideal for families seeking proximity to this prestigious National Blue Ribbon School within the Alief Independent School District. Choose from our spacious one and two bedroom floor plans, each designed for comfort with features like air conditioning, multi-speed fans, and a cozy wood-burning fireplace.\n\nFinley West is nestled in a lush environment with mature landscaping and offers exceptional amenities, including a resort-inspired swimming pool and a state-of-the-art fitness center. Managed by American Landmark, our community is dedicated to providing a welcoming atmosphere and top-notch service. With a focus on convenience and comfort, Finley West is the perfect place for families looking to settle near Alief Early College High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent In Houston TX Near Alief Early College High School",
      "seo_description": "Explore Finley West's family-friendly apartments for rent in Houston TX near Alief Early College High School. Enjoy spacious floor plans and modern amenities in a lush setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-houston-tx-near-middle-school",
      "search_query": "Apartments For Rent In Houston TX Near O'Donnell Middle School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston TX Near O'Donnell Middle School",
      "h2_subtitle": "Finley West offers family-friendly living just 10.7 km from O'Donnell Middle School. Enjoy spacious floor plans and modern amenities in a lush Houston setting.",
      "page_copy": "Discover the perfect apartments for rent in Houston TX near O'Donnell Middle School at Finley West. Located just 10.7 km away, our community is ideal for families seeking proximity to this neighborhood school within the Baltimore City Public Schools district. Choose from our spacious one and two bedroom floor plans, each designed for comfort with features like air conditioning, multi-speed fans, and a cozy wood-burning fireplace.\n\nFinley West is nestled in a lush environment with mature landscaping and offers exceptional amenities, including a resort-inspired swimming pool and a state-of-the-art fitness center. Managed by American Landmark, our community is dedicated to providing a welcoming atmosphere and top-notch service. With a focus on convenience and comfort, Finley West is the perfect place for families looking to settle near O'Donnell Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent In Houston TX Near O'Donnell Middle School",
      "seo_description": "Explore Finley West's family-friendly apartments for rent in Houston TX near O'Donnell Middle School. Enjoy spacious floor plans and modern amenities in a lush setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-houston-tx-near-budewig-intermediate",
      "search_query": "Apartments For Rent In Houston TX Near Budewig Intermediate School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston TX Near Budewig Intermediate School",
      "h2_subtitle": "Finley West offers family-friendly living just 5.9 km from Budewig Intermediate School. Enjoy spacious floor plans and modern amenities in a lush Houston setting.",
      "page_copy": "Discover the perfect apartments for rent in Houston TX near Budewig Intermediate School at Finley West. Located just 5.9 km away, our community is ideal for families seeking a user-friendly educational environment within the Alief Independent School District. Choose from our spacious one and two bedroom floor plans, each designed for comfort with features like air conditioning, multi-speed fans, and a cozy wood-burning fireplace.\n\nFinley West is nestled in a lush environment with mature landscaping and offers exceptional amenities, including a resort-inspired swimming pool and a state-of-the-art fitness center. Managed by American Landmark, our community is dedicated to providing a welcoming atmosphere and top-notch service. With a focus on convenience and comfort, Finley West is the perfect place for families looking to settle near Budewig Intermediate School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent In Houston TX Near Budewig Intermediate School",
      "seo_description": "Explore Finley West's family-friendly apartments for rent in Houston TX near Budewig Intermediate School. Enjoy spacious floor plans and modern amenities in a lush setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-houston-tx-near-odonnell-middle-school",
      "search_query": "Apartments For Rent In Houston TX Near O'Donnell Middle School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Houston TX Near O'Donnell Middle School",
      "h2_subtitle": "Finley West offers family-friendly living just 10.7 km from O'Donnell Middle School. Enjoy spacious floor plans and modern amenities in a lush Houston setting.",
      "page_copy": "Discover the perfect apartments for rent in Houston TX near O'Donnell Middle School at Finley West. Located just 10.7 km away, our community is ideal for families seeking proximity to this neighborhood school serving grades Pre-K to 8. Choose from our spacious one and two bedroom floor plans, each designed for comfort with features like air conditioning, multi-speed fans, and a cozy wood-burning fireplace.\n\nFinley West is nestled in a lush environment with mature landscaping and offers exceptional amenities, including a resort-inspired swimming pool and a state-of-the-art fitness center. Managed by American Landmark, our community is dedicated to providing a welcoming atmosphere and top-notch service. With a focus on convenience and comfort, Finley West is the perfect place for families looking to settle near O'Donnell Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent In Houston TX Near O'Donnell Middle School",
      "seo_description": "Explore Finley West's family-friendly apartments for rent in Houston TX near O'Donnell Middle School. Enjoy spacious floor plans and modern amenities in a lush setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5759777107869696",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-houston-tx-near-alief-school",
      "search_query": "Apartments For Rent In Houston TX Near Alief Early College High School",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Houston TX Near Alief Early College High School",
      "h2_subtitle": "Finley West offers family-friendly living just 3.5 km from Alief Early College High School. Enjoy spacious floor plans and modern amenities in a lush Houston setting.",
      "page_copy": "Explore the ideal apartments for rent in Houston TX near Alief Early College High School at Finley West. Located just 3.5 km away, our community is perfect for families seeking proximity to this prestigious National Blue Ribbon School within the Alief Independent School District. Choose from our spacious one and two bedroom floor plans, each designed for comfort with features like air conditioning, multi-speed fans, and a cozy wood-burning fireplace.\n\nFinley West is nestled in a lush environment with mature landscaping and offers exceptional amenities, including a resort-inspired swimming pool and a state-of-the-art fitness center. Managed by American Landmark, our community is dedicated to providing a welcoming atmosphere and top-notch service. With a focus on convenience and comfort, Finley West is the perfect place for families looking to settle near Alief Early College High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f6c0e-f754-75fe-95b7-a8ccd3fa69a6",
        "storage_key": "property/5759777107869696/019f6c0e-f754-75fe-95b7-a8ccd3fa69a6.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0f-0ba0-7610-bcaf-41543d6fe1aa",
        "storage_key": "property/5759777107869696/019f6c0f-0ba0-7610-bcaf-41543d6fe1aa.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Finley West | Apartments For Rent In Houston TX Near Alief Early College High School",
      "seo_description": "Explore Finley West's family-friendly apartments for rent in Houston TX near Alief Early College High School. Enjoy spacious floor plans and modern amenities in a lush setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2162"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471178"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a30\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a30\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4600725"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TQP3Z28"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://finleywest.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443864151"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/910pdo4ev2z"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "832-639-6826"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjV0dkRJWUFwZmJkS1Z0RGo2cjhzU2c9PSIsInZhbHVlIjoiQ1NDc3N3a2FiK09tQmo4aC9PTXFrUT09IiwibWFjIjoiNmNlYzdjNGEyODFmZWI3M2JkY2QxYWI5Njk0OWRjNTcyNjUzNmM5OWJjYjlhZTQ3NGEwZGRlOTQ0Y2M4NTA3MCJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2162",
  "custom_repli_id": "2376471178",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a30\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a30\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4600725",
  "custom_google_gtm_id": "GTM-TQP3Z28",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://finleywest.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443864151",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/910pdo4ev2z",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "832-639-6826",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjV0dkRJWUFwZmJkS1Z0RGo2cjhzU2c9PSIsInZhbHVlIjoiQ1NDc3N3a2FiK09tQmo4aC9PTXFrUT09IiwibWFjIjoiNmNlYzdjNGEyODFmZWI3M2JkY2QxYWI5Njk0OWRjNTcyNjUzNmM5OWJjYjlhZTQ3NGEwZGRlOTQ0Y2M4NTA3MCJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "f5b85c03-715c-455f-9d74-fe1461cfc551",
  "custom_audioeye_site_hash": "8481723d929ff450e92ac12e0d82e83c"
};

export const generatedAt = '2026-11-03T20:35:13.443Z';
